import { flushSync } from "react-dom";
import React, {
  useEffect,
  useRef,
  useState,
  useCallback,
  useMemo,
} from "react";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { ErrorToast, SuccessToast } from "../components/toastify";
// Mock Axios injected below
import HandleLogout from "../helpers/logout";
import Receipt from "../components/receipt";
import { useReactToPrint } from "react-to-print";
import ThaaiMamanLineUpModal from "../components/ThaaiMamanLineUpModal";

import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import QRCode from "qrcode";
import {
  DenominationMismatchAlert,
  DenominationErrorBanner,
} from "../components/DenominationAlert";
import { setTranslatorState } from "../store/userStatus";
import { setShowPreloader } from "../store/activePage";
import formatCustomDate from "../helpers/customDateFormat";
import {
  FaChevronDown,
  FaChevronUp,
  FaChevronRight,
  FaChevronLeft,
  FaQuestionCircle,
  FaKeyboard,
  FaHome,
  FaWifi,
  FaSync,
  FaExpand,
  FaCompress,
} from "react-icons/fa";
import { IoLogOutOutline } from "react-icons/io5";
import { MdSignalWifiOff, MdWarning } from "react-icons/md";
import CitySearchSelect from "../components/city-search-select";
import ConsolidatedVillageInput from "../components/ConsolidatedVillageInput";
import VillageAreaInput from "../components/VillageAreaInput";
import VillageUserNameInput from "../components/VillageUserNameInput";
// Mock db injected below
import { v4 as uuidv4 } from "uuid";
import useNetworkStatus from "../hooks/useNetworkStatus";

// ─── MOCK DATA & MOCK AXIOS FOR TRAINING MODE ──────────────────────────────────
let staticEntries = [];
try {
  const stored = localStorage.getItem("training-entries");
  staticEntries = stored ? JSON.parse(stored) : [];
  if (!Array.isArray(staticEntries)) staticEntries = [];
} catch (e) {
  staticEntries = [];
}

const saveStaticEntries = () => {
  localStorage.setItem("training-entries", JSON.stringify(staticEntries));
};


let staticTokens = { total: 0, pending: 0, completed: 0, available_tokens: Array.from({length: 100}, (_, i) => i + 1) };
let staticEventInfo = {
  operator_id: 999,
  operator_name: "Training Operator",
  event_id: 1000,
  event_name: "Training Event",
  customer_name: "Training Customer",
  vendor_name: "Digital Moi Tech",
  event_type: "Training",
  event_date: new Date().toISOString(),
  event_address: "Training Address",
  villages: "Chennai, Madurai, Coimbatore, Trichy",
  operator_settings: {
    allow_assets: true,
    allow_online_payments: true,
    allow_thaai_maman: true,
    asset_types: ["cash", "online", "ornaments", "things"],
    default_asset_type: "cash",
    print_receipt: true,
    collect_mobile: true,
    collect_family_name: true,
    collect_city: true,
    force_denomination: false,
    theme_color: "indigo"
  }
};

const AxiosGetMethod = async (url) => {
  if (url.includes("operator/info")) return { status: 200, data: { data: staticEventInfo } };
  if (url.includes("entry/list")) return { status: 200, data: { data: [...staticEntries] } };
  if (url.includes("entry/tokens")) return { status: 200, data: { data: staticTokens } };
  if (url.includes("entry/users-by-village")) {
    const urlObj = new URL(url, "http://localhost");
    const village = (urlObj.searchParams.get("village") || "").trim().toLowerCase();
    const area = (urlObj.searchParams.get("area") || "").trim().toLowerCase();
    const defaultSampleUsers = [
      { name: "பொம்முராஜ்", family_name: "யோகன்", mobile: "8248754411", village: "திருமங்கலம்", area: "அண்ணா நகர்", city: "மதுரை", state: "தமிழ்நாடு", occupation: "பிசினெஸ்" },
      { name: "யோகன்", family_name: "ஜெயப்ரகாஷ்", mobile: "8248754410", village: "திருமங்கலம்", area: "காந்தி நகர்", city: "மதுரை", state: "தமிழ்நாடு", occupation: "பிசினஸ்" },
      { name: "ஜெயப்ரகாஷ்", family_name: "முருகன்", mobile: "9876543212", village: "திருமங்கலம்", area: "பஸ் நிலையம் அருகில்", city: "மதுரை", state: "தமிழ்நாடு", occupation: "டாக்டர்" },
      { name: "அமர்நாத்", family_name: "ராமர்", mobile: "9876543213", village: "திருமங்கலம்", area: "மெயின் ரோடு", city: "மதுரை", state: "தமிழ்நாடு", occupation: "ஆசிரியர்" },
      { name: "செந்தில்குமார்", family_name: "சுந்தரம்", mobile: "9876543214", village: "மதுரை", area: "சிம்மக்கல்", city: "மதுரை", state: "தமிழ்நாடு", occupation: "இன்ஜினியர்" },
    ];
    const sourceUsers = [...defaultSampleUsers, ...(staticEntries || [])];
    const matching = sourceUsers
      .filter((e) => {
        const v = (e.village || "").toLowerCase();
        if (!v.includes(village)) return false;
        if (area) {
          const a = (e.area || "").toLowerCase();
          if (!a.includes(area)) return false;
        }
        return true;
      })
      .map((e) => ({
        name: e.name || "",
        family_name: e.family_name || "",
        mobile: e.mobile || "",
        village: e.village || "",
        area: e.area || "",
        city: e.city || "",
        state: e.state || "",
        occupation: e.occupation || "",
      }));
    return { status: 200, data: { data: matching } };
  }
  if (url.includes("entry/villages")) {
    const defaultVillages = [
      { village: "திருமங்கலம்", village_en: "thirumangalam" },
      { village: "மதுரை", village_en: "madurai" },
      { village: "மேலூர்", village_en: "melur" },
      { village: "உசிலம்பட்டி", village_en: "usilampatti" },
      { village: "சோழவந்தான்", village_en: "sholavandan" },
      { village: "வடிப்பட்டி", village_en: "vadipatti" },
      { village: "காளவாசல்", village_en: "kalavasal" },
      { village: "அருப்புக்கோட்டை", village_en: "aruppukottai" },
      { village: "செக்கானூரணி", village_en: "chekkanurani" },
    ];
    const localVillages = (staticEntries || [])
      .map((e) => (e.village || "").trim())
      .filter(Boolean)
      .map((v) => ({ village: v, village_en: "" }));
    const merged = [...defaultVillages, ...localVillages];
    const unique = [];
    const seen = new Set();
    for (const item of merged) {
      const v = item.village;
      if (v && !seen.has(v.toLowerCase())) {
        seen.add(v.toLowerCase());
        unique.push(item);
      }
    }
    return { status: 200, data: { data: unique } };
  }
  if (url.includes("entry/areas-by-village")) {
    const urlObj = new URL(url, "http://localhost");
    const village = (urlObj.searchParams.get("village") || "").trim();
    const defaultAreasByVillage = {
      "திருமங்கலம்": ["அண்ணா நகர்", "காந்தி நகர்", "மெயின் ரோடு", "பஸ் நிலையம் அருகில்", "காமராஜர் தெரு"],
      "மதுரை": ["கே.கே. நகர்", "அண்ணா நகர்", "சிம்மக்கல்", "தல்லாகுளம்", "கோரிப்பாளையம்", "ஆரப்பாளையம்"],
      "மேலூர்": ["பஸ் நிலையம்", "சந்தை ரோடு", "செக்கடி"],
    };
    const defaultList = defaultAreasByVillage[village] || ["மெயின் ரோடு", "காந்தி நகர்", "அண்ணா நகர்"];
    const localAreas = (staticEntries || [])
      .filter((e) => e.village && e.village.trim() === village && e.area)
      .map((e) => e.area.trim());
    const merged = Array.from(new Set([...defaultList, ...localAreas].filter(Boolean)));
    return { status: 200, data: { data: merged } };
  }
  if (url.includes("thaai-maman/list")) return { status: 200, data: { data: [] } };
  if (url.includes("existing-customer") || url.includes("get-info-by-mobile")) {
    const urlObj = new URL(url, "http://localhost");
    const mobile = urlObj.searchParams.get('mobile');
    
    // Sample permanent customer matching 9999999999
    if (mobile === "9999999999") {
      return {
        status: 200,
        data: {
          data: {
            first_name: "ரமேஷ்",
            last_name: "முருகன் வகைறா",
            mobile: "9999999999",
            city: "மதுரை",
            village: "மேலூர்",
            state: "தமிழ்நாடு",
            customer_id: "VIP-999"
          }
        }
      };
    }
    return { data: null, status: 404 };
  }
  
  if (url.includes("get-token-details")) {
    const urlObj = new URL(url, "http://localhost");
    const token = urlObj.searchParams.get('token');
    
    if (token) {
      return {
        status: 200,
        data: {
          data: [
            {
              amount: 1000,
              asset_type: "cash",
              asset: "",
              name: "சுரேஷ் " + token,
              occupation: "வியாபாரம்",
              village: "மதுரை",
              city: "மதுரை",
              state: "தமிழ்நாடு",
              family_name: "பாண்டியன் வகைறா",
              mobile: "9876543210"
            }
          ]
        }
      };
    }
    return { data: null, status: 404 };
  }
  
  return {};
};

const AxiosPostMethod = async (url, data) => {
  if (url.includes("entry/new")) {
    const newEntry = {
      ...data,
      id: uuidv4(),
      entry_id: uuidv4(),
      datetime: new Date().toISOString(),
      created_at: new Date().toISOString(),
      is_edited: false
    };
    staticEntries = [newEntry, ...staticEntries];
    saveStaticEntries();
    return { status: 200, data: { success: true, message: "Entry added", entry_id: newEntry.entry_id } };
  }
  if (url.includes("register-customer")) {
    return { status: 200, data: { success: true } };
  }
  return { status: 200, data: { success: true } };
};

const AxiosPutMethod = async (url, data) => {
  if (url === "entry/update") {
    const idx = staticEntries.findIndex(e => e.entry_id === data.entry_id || e.id === data.entry_id);
    if (idx !== -1) {
      staticEntries[idx] = { ...staticEntries[idx], ...data, is_edited: true };
      saveStaticEntries();
    }
    return { status: 200, data: { success: true } };
  }
  if (url === "entry/thaai-maman") {
    return { status: 200, data: { success: true } };
  }
  return { status: 200, data: { success: true } };
};

const db = {
  pendingEntries: {
    count: async () => 0,
    toArray: async () => [],
    delete: async () => {},
    update: async () => {},
    add: async () => "mock-id",
    where: () => ({ equals: () => ({ toArray: async () => [] }) })
  },
  syncQueue: {
    add: async () => {}
  }
};

// ─── Constants ────────────────────────────────────────────────────────────────
const DENOMS = [500, 200, 100, 50, 20, 10, 5, 1];

const ASSET_CONFIG = {
  cash: {
    label: "Cash",
    icon: "💵",
    color: "bg-emerald-100 text-emerald-700 border-emerald-200",
  },
  online: {
    label: "Online",
    icon: "📲",
    color: "bg-blue-100 text-blue-700 border-blue-200",
  },
  ornaments: {
    label: "Ornaments",
    icon: "💍",
    color: "bg-amber-100 text-amber-700 border-amber-200",
  },
  things: {
    label: "Things",
    icon: "🎁",
    color: "bg-violet-100 text-violet-700 border-violet-200",
  },
};

// ─── Export helpers ───────────────────────────────────────────────────────────
const exportTextDecoder =
  typeof TextDecoder !== "undefined"
    ? new TextDecoder("utf-8", { fatal: false })
    : null;

function normalizeExportText(value) {
  const raw = String(value ?? "");
  if (!raw || !exportTextDecoder) return raw;

  const looksMojibake = /(?:Ã.|Â.|â.|à.|ðŸ)/.test(raw);
  if (!looksMojibake) return raw;

  try {
    const bytes = Uint8Array.from(
      Array.from(raw, (char) => char.charCodeAt(0) & 0xff),
    );
    const repaired = exportTextDecoder.decode(bytes);
    return repaired.includes("\uFFFD") ? raw : repaired;
  } catch (error) {
    return raw;
  }
}

function escapeHtml(value) {
  return normalizeExportText(value)
    .split("&")
    .join("&amp;")
    .split("<")
    .join("&lt;")
    .split(">")
    .join("&gt;");
}

function formatCurrency(value) {
  return `₹${(parseFloat(value) || 0).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
}

function formatCurrencyTamil(value) {
  return `ரூ ${Number(parseFloat(value) || 0).toLocaleString("ta-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
}

function normalizeDateValue(value) {
  if (value === null || value === undefined || value === "") return null;
  if (typeof value === "string") {
    const trimmed = value.trim();
    return trimmed.replace(
      /^(\d{4}-\d{2}-\d{2})[ ](\d{2}:\d{2}(?::\d{2})?)$/,
      "$1T$2",
    );
  }
  return value;
}

function parseIndiaDate(value) {
  if (!value) return null;
  if (value instanceof Date) return value;

  const raw = String(value).trim();
  const normalized = raw.replace(/ /g, "T");
  if (/Z|[+-]\d{2}:?\d{2}$/.test(normalized)) {
    const parsed = new Date(normalized);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
  }

  const match = normalized.match(
    /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2}))?$/,
  );
  if (!match) {
    const parsed = new Date(normalized);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
  }

  const [, year, month, day, hour, minute, second = "00"] = match;
  const utcMs =
    Date.UTC(
      Number(year),
      Number(month) - 1,
      Number(day),
      Number(hour),
      Number(minute),
      Number(second),
    ) - 5.5 * 60 * 60 * 1000;
  return new Date(utcMs);
}

function formatIndiaDateTime(value, locale, options) {
  const date = parseIndiaDate(value);
  if (!date || Number.isNaN(date.getTime())) return String(value);

  return new Intl.DateTimeFormat(locale, {
    timeZone: "Asia/Kolkata",
    ...options,
  }).format(date);
}

function formatEntryDateTime(value) {
  if (!value) return "—";

  return formatIndiaDateTime(value, "en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
}

function formatEntryDateTimeTamil(value) {
  if (!value) return "இல்லை";

  return formatIndiaDateTime(value, "ta-IN", {
    day: "2-digit",
    month: "long",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
}

function parseOnlinePaymentDetails(value) {
  if (!value) return null;

  try {
    return JSON.parse(value);
  } catch (error) {
    return { raw_details: String(value) };
  }
}

function buildUpiPaymentUri({ upiId, note }) {
  if (!upiId) return "";

  const params = new URLSearchParams({
    pa: upiId,
    cu: "INR",
  });

  if (note) {
    params.set("tn", note);
  }

  return `upi://pay?${params.toString()}`;
}

function getCombinedName(name, initial) {
  const cleanName = name ? String(name).trim() : "";
  const cleanInitial = initial ? String(initial).trim() : "";
  if (!cleanInitial) return cleanName;
  if (!cleanName) return cleanInitial;
  if (
    cleanName.endsWith(" " + cleanInitial) ||
    cleanName.startsWith(cleanInitial + " ") ||
    cleanName === cleanInitial
  ) {
    return cleanName;
  }
  return `${cleanName} ${cleanInitial}`;
}

function parseNameAndInitial(fullName) {
  if (!fullName || typeof fullName !== "string") {
    return { name: "", initial: "" };
  }
  const trimmed = fullName.trim();
  if (!trimmed) {
    return { name: "", initial: "" };
  }

  // 1. Leading initial with space or dot: e.g. "J. Ramesh", "J Ramesh", "J.K. Ramesh", "ஜெ. பொம்முராஜ்", "ஜெ பொம்முராஜ்"
  const leadingMatch = trimmed.match(
    /^([A-Za-z\u0B80-\u0BFF]{1,4}(?:\.[A-Za-z\u0B80-\u0BFF]{1,4})*)\.?\s+(.+)$/
  );
  if (leadingMatch) {
    const initCandidate = leadingMatch[1].replace(/\.$/, "").trim();
    const nameCandidate = leadingMatch[2].trim();
    const strippedInit = initCandidate.replace(/\./g, "");
    if (
      strippedInit.length >= 1 &&
      strippedInit.length <= 4 &&
      !/^\d+$/.test(strippedInit) &&
      nameCandidate.length > 0
    ) {
      return {
        name: nameCandidate,
        initial: initCandidate.toUpperCase(),
      };
    }
  }

  // Leading initial with dot directly attached without space: "J.பொம்முராஜ்", "K.சுரேஷ்"
  const leadingDotMatch = trimmed.match(
    /^([A-Za-z\u0B80-\u0BFF]{1,3}(?:\.[A-Za-z\u0B80-\u0BFF]{1,3})*)\.([^\s.]+.*)$/
  );
  if (leadingDotMatch) {
    const initCandidate = leadingDotMatch[1].trim();
    const nameCandidate = leadingDotMatch[2].trim();
    const strippedInit = initCandidate.replace(/\./g, "");
    if (
      strippedInit.length >= 1 &&
      strippedInit.length <= 4 &&
      !/^\d+$/.test(strippedInit) &&
      nameCandidate.length > 0
    ) {
      return {
        name: nameCandidate,
        initial: initCandidate.toUpperCase(),
      };
    }
  }

  // 2. Trailing initial with dot attached without space: "பொம்முராஜ்.J"
  const trailingDotMatch = trimmed.match(
    /^(.+?)\.([A-Za-z\u0B80-\u0BFF]{1,3}(?:\.[A-Za-z\u0B80-\u0BFF]{1,3})*)\.?$/
  );
  if (trailingDotMatch) {
    const nameCandidate = trailingDotMatch[1].trim();
    const initCandidate = trailingDotMatch[2].replace(/\.$/, "").trim();
    const strippedInit = initCandidate.replace(/\./g, "");
    if (
      strippedInit.length >= 1 &&
      strippedInit.length <= 4 &&
      !/^\d+$/.test(strippedInit) &&
      nameCandidate.length > 0
    ) {
      return {
        name: nameCandidate,
        initial: initCandidate.toUpperCase(),
      };
    }
  }

  // Trailing initial with space: "பொம்முராஜ் J", "பொம்முராஜ் K.", "பொம்முராஜ் J.K"
  const parts = trimmed.split(/\s+/);
  if (parts.length > 1) {
    const lastPart = parts[parts.length - 1];
    const stripped = lastPart.replace(/\./g, "");
    if (
      stripped.length >= 1 &&
      stripped.length <= 4 &&
      !/^\d+$/.test(stripped)
    ) {
      return {
        name: parts.slice(0, -1).join(" "),
        initial: stripped.toUpperCase(),
      };
    }
  }

  return { name: trimmed, initial: "" };
}

function getCustomerRegistrationPayload(values) {
  const combinedName = getCombinedName(values.name, values.initial);
  return {
    first_name: combinedName,
    last_name: values.familyName || "-",
    occupation: values.occupation || "-",
    mobile: values.mobile,
    email: `${values.mobile}@moinote.local`,
    password: values.mobile,
    plot_no: "-",
    address: [values.village, values.area, values.city].filter(Boolean).join(", ") || "-",
    city: values.city || values.village || "-",
    state: values.state,
    pincode: "000000",
  };
}

function getEntryDateTime(entry) {
  return entry?.datetime || entry?.created_at || entry?.createdAt || "";
}

function maskMobileNumber(mobile) {
  const digits = String(mobile ?? "").replace(/\D/g, "");
  if (!digits) return "இல்லை";
  if (digits.length <= 4) return digits;
  return `${"*".repeat(digits.length - 4)}${digits.slice(-4)}`;
}

function isThaaiMamanEntry(entry) {
  return (
    entry?.thaai_maman === true ||
    entry?.thaai_maman === 1 ||
    entry?.thaai_maman === "1"
  );
}

function isEditedEntry(entry) {
  return (
    entry?.is_edited === true ||
    entry?.is_edited === 1 ||
    entry?.is_edited === "1"
  );
}

function getEditedStatusLabel(entry) {
  return isEditedEntry(entry) ? "Edited Entry" : "Original Entry";
}

function getTamilAssetTypeLabel(assetType) {
  switch (assetType) {
    case "cash":
      return "பணம்";
    case "online":
      return "ஆன்லைன்";
    case "ornaments":
      return "நகை";
    case "things":
      return "பொருள்";
    default:
      return assetType || "இல்லை";
  }
}

function getScreenEntryAmount(entry) {
  const raw = entry?.amount;
  if (raw === null || raw === undefined || raw === "") return "-";
  const parsed = parseFloat(raw);
  if (Number.isNaN(parsed)) return "-";
  return formatCurrency(parsed);
}

function getExportEntryAmount(entry) {
  const raw = entry?.amount;
  if (raw === null || raw === undefined || raw === "") return "இல்லை";
  const parsed = parseFloat(raw);
  if (Number.isNaN(parsed)) return "இல்லை";
  return formatCurrencyTamil(parsed);
}

function sortEntriesForExport(entries) {
  return [...entries]
    .map((entry, index) => ({ entry, index }))
    .sort((a, b) => {
      const thaiDiff =
        Number(isThaaiMamanEntry(b.entry)) - Number(isThaaiMamanEntry(a.entry));
      if (thaiDiff !== 0) return thaiDiff;

      if (isThaaiMamanEntry(a.entry)) {
        const orderA = a.entry.thaai_maman_order !== null && a.entry.thaai_maman_order !== undefined ? Number(a.entry.thaai_maman_order) : Infinity;
        const orderB = b.entry.thaai_maman_order !== null && b.entry.thaai_maman_order !== undefined ? Number(b.entry.thaai_maman_order) : Infinity;
        if (orderA !== orderB) return orderA - orderB;
      }

      return a.index - b.index;
    })
    .map(({ entry }) => entry);
}

function parseDenominationBreakdown(entry) {
  const breakdown = entry?.denomination_breakdown;
  if (breakdown && typeof breakdown === "object" && !Array.isArray(breakdown)) {
    return breakdown;
  }

  if (
    typeof entry?.denomination_amount === "string" &&
    entry.denomination_amount.trim()
  ) {
    try {
      const parsed = JSON.parse(entry.denomination_amount);
      if (parsed && typeof parsed === "object" && !Array.isArray(parsed)) {
        return parsed;
      }
    } catch (error) {
      return null;
    }
  }

  return null;
}

function getEntryDenominationTotal(entry) {
  const denominationBreakdown = parseDenominationBreakdown(entry);
  if (!denominationBreakdown) return null;

  const total = Object.entries(denominationBreakdown).reduce(
    (sum, [note, count]) =>
      sum + (parseInt(note, 10) || 0) * (parseInt(count, 10) || 0),
    0,
  );

  return total > 0 ? total : null;
}

function getEntryDenominationSummary(entry) {
  const denominationBreakdown = parseDenominationBreakdown(entry);
  if (!denominationBreakdown) return "-";

  const parts = Object.entries(denominationBreakdown)
    .map(([note, count]) => ({
      note: parseInt(note, 10) || 0,
      count: parseInt(count, 10) || 0,
    }))
    .filter(({ note, count }) => note > 0 && count > 0)
    .sort((a, b) => b.note - a.note)
    .map(({ note, count }) => `${note} x ${count}`);

  return parts.length ? parts.join(", ") : "-";
}

function getEntryReturnAmount(entry) {
  const denominationTotal = getEntryDenominationTotal(entry);
  if (denominationTotal === null) return null;

  const amountValue = parseFloat(entry?.amount) || 0;
  const difference = denominationTotal - amountValue;

  return difference > 0 ? difference : 0;
}

function getOverallDenominationCounts(entries) {
  return entries.reduce((acc, entry) => {
    const denominationBreakdown = parseDenominationBreakdown(entry);
    if (!denominationBreakdown) return acc;

    Object.entries(denominationBreakdown).forEach(([note, count]) => {
      const parsedNote = parseInt(note, 10) || 0;
      const parsedCount = parseInt(count, 10) || 0;
      if (parsedNote <= 0 || parsedCount <= 0) return;
      acc[parsedNote] = (acc[parsedNote] || 0) + parsedCount;
    });

    return acc;
  }, {});
}

function getOverallReturnAmount(entries) {
  return entries.reduce((sum, entry) => {
    const returnAmount = getEntryReturnAmount(entry);
    return sum + (returnAmount || 0);
  }, 0);
}

function buildOverallDenominationHtml(entries) {
  const totals = getOverallDenominationCounts(entries);
  const totalReturnAmount = getOverallReturnAmount(entries);
  const rows = Object.entries(totals)
    .map(([note, count]) => ({
      note: parseInt(note, 10) || 0,
      count: parseInt(count, 10) || 0,
    }))
    .filter(({ note, count }) => note > 0 && count > 0)
    .sort((a, b) => b.note - a.note)
    .map(
      ({ note, count }) => `
        <tr>
          <td>${formatCurrencyTamil(note)}</td>
          <td>${Number(count).toLocaleString("ta-IN")}</td>
          <td>${formatCurrencyTamil(note * count)}</td>
        </tr>
      `,
    )
    .join("");

  if (!rows) {
    return `
      <div class="section">
        <div class="section-title">மொத்த நோட்டு விவரம்</div>
        <p>நோட்டு விவரம் இல்லை.</p>
      </div>
    `;
  }

  return `
    <div class="section">
      <div class="section-title">மொத்த நோட்டு விவரம்</div>
      <table class="entries-table">
        <thead>
          <tr>
            <th>நோட்டு</th>
            <th>எண்ணிக்கை</th>
            <th>மொத்தம்</th>
          </tr>
        </thead>
        <tbody>${rows}</tbody>
        <tfoot>
          <tr>
            <td colspan="2"><strong>மீதி மொத்தம்</strong></td>
            <td><strong>${formatCurrencyTamil(totalReturnAmount)}</strong></td>
          </tr>
        </tfoot>
      </table>
    </div>
  `;
}

function buildExportStats(entries) {
  const cashEntries = entries.filter((e) => e.asset_type === "cash");
  const onlineEntries = entries.filter((e) => e.asset_type === "online");
  const ornamentEntries = entries.filter((e) => e.asset_type === "ornaments");
  const thingEntries = entries.filter((e) => e.asset_type === "things");
  const thaaiMamanEntries = entries.filter((e) => isThaaiMamanEntry(e));

  const totalCash = cashEntries.reduce(
    (sum, entry) => sum + (parseFloat(entry.amount) || 0),
    0,
  );
  const totalOnline = onlineEntries.reduce(
    (sum, entry) => sum + (parseFloat(entry.amount) || 0),
    0,
  );
  const totalMonetary = totalCash + totalOnline;
  const thaaiMamanTotal = thaaiMamanEntries.reduce(
    (sum, entry) => sum + (parseFloat(entry.amount) || 0),
    0,
  );

  return {
    totalEntries: entries.length,
    totalCash,
    totalOnline,
    totalMonetary,
    thaaiMamanCount: thaaiMamanEntries.length,
    thaaiMamanTotal,
    ornamentsCount: ornamentEntries.length,
    thingsCount: thingEntries.length,
    giftAssetCount: ornamentEntries.length + thingEntries.length,
  };
}

function buildThaaiMamanSummaryHtml(stats) {
  return `
    <div class="section">
      <div class="section-title">தாய்மாமன் சிறப்பு சுருக்கம்</div>
      <div class="stats-grid">
        <div class="stat-card">
          <div class="stat-label">தாய்மாமன் பதிவுகள்</div>
          <div class="stat-value">${Number(stats.thaaiMamanCount || 0).toLocaleString("ta-IN")}</div>
        </div>
        <div class="stat-card">
          <div class="stat-label">தாய்மாமன் மொத்தம்</div>
          <div class="stat-value">${formatCurrencyTamil(stats.thaaiMamanTotal || 0)}</div>
        </div>
      </div>
    </div>
  `;
}

function downloadFile(content, fileName, mimeType) {
  const blob = new Blob([content], { type: mimeType });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}

function resolveVendorPhone(eventInfo, vendorName) {
  const directPhone = eventInfo?.vendor_mobile || eventInfo?.vendorPhone;
  if (directPhone) return directPhone;

  const vendorEntry = eventInfo?.[vendorName];
  if (typeof vendorEntry === "string") return vendorEntry;
  if (vendorEntry && typeof vendorEntry === "object") {
    return (
      vendorEntry.phone ||
      vendorEntry.mobile ||
      vendorEntry.vendor_mobile ||
      vendorEntry.vendorPhone ||
      "—"
    );
  }

  return "—";
}

function buildVendorInfoHtml(eventInfo) {
  const vendorName =
    eventInfo?.vendor_name || eventInfo?.vendorName || "Digital Moi Tech";
  const vendorPhone = resolveVendorPhone(eventInfo, vendorName);
  const vendorAddress =
    eventInfo?.vendor_address || eventInfo?.vendorAddress || "—";
  const customerName = eventInfo?.customer_name || "—";
  const eventType = eventInfo?.event_type || "—";
  const eventDate = formatCustomDate(eventInfo?.event_date, "date") || "—";
  const eventAddress = eventInfo?.event_address || "—";

  return `
    <div class="section">
      <div class="section-title">விற்பனையாளர் விவரம்</div>
      <table class="meta-table">
        <tr><td>விற்பனையாளர் பெயர்</td><td>${escapeHtml(vendorName)}</td></tr>
        <tr><td>முகவரி</td><td>${escapeHtml(vendorAddress)}</td></tr>
        <tr><td>தொலைபேசி</td><td>${escapeHtml(vendorPhone)}</td></tr>
      </table>
    </div>

    <div class="section">
      <div class="section-title">விழா விவரம்</div>
      <table class="meta-table">
        <tr><td>வாடிக்கையாளர் பெயர்</td><td>${escapeHtml(customerName)}</td></tr>
        <tr><td>விழா வகை</td><td>${escapeHtml(eventType)}</td></tr>
        <tr><td>விழா தேதி</td><td>${escapeHtml(eventDate)}</td></tr>
        <tr><td>விழா முகவரி</td><td>${escapeHtml(eventAddress)}</td></tr>
      </table>
    </div>
  `;
}

function buildTallyHtml(stats) {
  return `
    <div class="section">
      <div class="section-title">மொத்த சுருக்கம்</div>
      <div class="stats-grid">
        <div class="stat-card">
          <div class="stat-label">மொத்த பதிவுகள்</div>
          <div class="stat-value">${Number(stats.totalEntries).toLocaleString("ta-IN")}</div>
        </div>
        <div class="stat-card">
          <div class="stat-label">பண மொத்தம்</div>
          <div class="stat-value">${formatCurrencyTamil(stats.totalCash)}</div>
        </div>
        <div class="stat-card">
          <div class="stat-label">ஆன்லைன் மொத்தம்</div>
          <div class="stat-value">${formatCurrencyTamil(stats.totalOnline)}</div>
        </div>
        <div class="stat-card">
          <div class="stat-label">பணம் மொத்தம்</div>
          <div class="stat-value">${formatCurrencyTamil(stats.totalMonetary)}</div>
        </div>
        <div class="stat-card">
          <div class="stat-label">நகை எண்ணிக்கை</div>
          <div class="stat-value">${Number(stats.ornamentsCount).toLocaleString("ta-IN")}</div>
        </div>
        <div class="stat-card">
          <div class="stat-label">பொருள் எண்ணிக்கை</div>
          <div class="stat-value">${Number(stats.thingsCount).toLocaleString("ta-IN")}</div>
        </div>
      </div>
    </div>
  `;
}

function buildEntriesTableHtml(entries) {
  const rows = entries
    .map(
      (entry, index) => `
        <tr>
          <td>${index + 1}</td>
          <td>${escapeHtml(entry.name || "—")}</td>
          <td>${escapeHtml(entry.family_name || "—")}</td>
          <td>${escapeHtml(maskMobileNumber(entry.mobile))}</td>
          <td>${escapeHtml(entry.village || "—")}</td>
          <td>${escapeHtml(entry.city || "—")}</td>
          <td>${escapeHtml(entry.state || "—")}</td>
          <td>${escapeHtml(entry.asset_type || "—")}</td>
          <td>${formatCurrency(entry.amount || 0)}</td>
          <td>${getEntryDenominationTotal(entry) !== null ? formatCurrency(getEntryDenominationTotal(entry)) : "-"}</td>
          <td>${escapeHtml(getEntryDenominationSummary(entry))}</td>
          <td>${getEntryReturnAmount(entry) !== null ? formatCurrency(getEntryReturnAmount(entry)) : "-"}</td>
          <td>${escapeHtml(entry.asset || "—")}</td>
          <td>${escapeHtml(entry.token || "—")}</td>
          <td>${escapeHtml(formatEntryDateTime(entry.datetime || entry.created_at))}</td>
        </tr>
      `,
    )
    .join("");

  return `
    <div class="section">
      <div class="section-title">Entry Details</div>
      <table class="entries-table">
        <thead>
          <tr>
            <th>#</th>
            <th>Name</th>
            <th>Family</th>
            <th>Mobile</th>
            <th>Village</th>
            <th>City</th>
            <th>State</th>
            <th>Type</th>
            <th>Amount</th>
            <th>Denom Total</th>
            <th>Denomination</th>
            <th>Return</th>
            <th>Asset</th>
            <th>Token</th>
            <th>Date & Time</th>
          </tr>
        </thead>
        <tbody>${rows || '<tr><td colspan="15">No entries available</td></tr>'}</tbody>
      </table>
    </div>
  `;
}

function buildDisclaimerHtml() {
  return `
    <div class="disclaimer">
      <strong>Disclaimer:</strong> This document contains confidential event and contribution data.
      If you leak this data, it will lead to severe action.
    </div>
  `;
}

function buildVendorInfoHtmlTamil(eventInfo) {
  const vendorName =
    eventInfo?.vendor_name || eventInfo?.vendorName || "Digital Moi Tech";
  const vendorPhone = resolveVendorPhone(eventInfo, vendorName);
  const vendorAddress =
    eventInfo?.vendor_address || eventInfo?.vendorAddress || "இல்லை";
  const customerName = eventInfo?.customer_name || "இல்லை";
  const eventType = eventInfo?.event_type || "இல்லை";
  const eventDate = formatCustomDate(eventInfo?.event_date, "date") || "இல்லை";
  const eventAddress = eventInfo?.event_address || "இல்லை";

  return `
    <div class="section">
      <div class="section-title">விசேஷ வீட்டாளர் விவரம்</div>
      <table class="meta-table">
        <tr><td>விசேஷ வீட்டாளர் பெயர்</td><td>${escapeHtml(vendorName)}</td></tr>
        <tr><td>முகவரி</td><td>${escapeHtml(vendorAddress)}</td></tr>
        <tr><td>தொலைபேசி</td><td>${escapeHtml(vendorPhone)}</td></tr>
      </table>
    </div>

    <div class="section">
      <div class="section-title">விழா விவரம்</div>
      <table class="meta-table">
        <tr><td>வாடிக்கையாளர் பெயர்</td><td>${escapeHtml(customerName)}</td></tr>
        <tr><td>விழா வகை</td><td>${escapeHtml(eventType)}</td></tr>
        <tr><td>விழா தேதி</td><td>${escapeHtml(eventDate)}</td></tr>
        <tr><td>விழா முகவரி</td><td>${escapeHtml(eventAddress)}</td></tr>
      </table>
    </div>
  `;
}

function buildTallyHtmlTamil(stats) {
  return `
    <div class="section">
      <div class="section-title">மொத்த சுருக்கம்</div>
      <div class="stats-grid">
        <div class="stat-card">
          <div class="stat-label">மொத்த பதிவுகள்</div>
          <div class="stat-value">${Number(stats.totalEntries).toLocaleString("ta-IN")}</div>
        </div>
        <div class="stat-card">
          <div class="stat-label">பண மொத்தம்</div>
          <div class="stat-value">${formatCurrencyTamil(stats.totalCash)}</div>
        </div>
        <div class="stat-card">
          <div class="stat-label">ஆன்லைன் மொத்தம்</div>
          <div class="stat-value">${formatCurrencyTamil(stats.totalOnline)}</div>
        </div>
        <div class="stat-card">
          <div class="stat-label">பணம் மொத்தம்</div>
          <div class="stat-value">${formatCurrencyTamil(stats.totalMonetary)}</div>
        </div>
        <div class="stat-card">
          <div class="stat-label">நகை எண்ணிக்கை</div>
          <div class="stat-value">${Number(stats.ornamentsCount).toLocaleString("ta-IN")}</div>
        </div>
        <div class="stat-card">
          <div class="stat-label">பொருள் எண்ணிக்கை</div>
          <div class="stat-value">${Number(stats.thingsCount).toLocaleString("ta-IN")}</div>
        </div>
      </div>
    </div>
  `;
}

function buildThaaiMamanSummaryHtmlTamil(stats) {
  return `
    <div class="section">
      <div class="section-title">தாய்மாமன் சிறப்பு சுருக்கம்</div>
      <div class="stats-grid">
        <div class="stat-card">
          <div class="stat-label">தாய்மாமன் பதிவுகள்</div>
          <div class="stat-value">${Number(stats.thaaiMamanCount || 0).toLocaleString("ta-IN")}</div>
        </div>
        <div class="stat-card">
          <div class="stat-label">தாய்மாமன் மொத்தம்</div>
          <div class="stat-value">${formatCurrencyTamil(stats.thaaiMamanTotal || 0)}</div>
        </div>
      </div>
    </div>
  `;
}

function buildEntryTableRowsTamil(entries) {
  return entries
    .map(
      (entry, index) => `
        <tr>
          <td>${Number(index + 1).toLocaleString("ta-IN")}</td>
          <td>${escapeHtml(entry.name || "இல்லை")}</td>
          <td>${escapeHtml(entry.family_name || "இல்லை")}</td>
          <td>${escapeHtml(maskMobileNumber(entry.mobile))}</td>
          <td>${escapeHtml(entry.village || "இல்லை")}</td>
          <td>${escapeHtml(entry.city || "இல்லை")}</td>
          <td>${escapeHtml(entry.state || "இல்லை")}</td>
          <td>${escapeHtml(getTamilAssetTypeLabel(entry.asset_type))}</td>
          <td>${getExportEntryAmount(entry)}</td>
          <td>${getEntryDenominationTotal(entry) !== null ? formatCurrencyTamil(getEntryDenominationTotal(entry)) : "இல்லை"}</td>
          <td>${escapeHtml(getEntryDenominationSummary(entry) === "-" ? "இல்லை" : getEntryDenominationSummary(entry))}</td>
          <td>${getEntryReturnAmount(entry) !== null ? formatCurrencyTamil(getEntryReturnAmount(entry)) : "இல்லை"}</td>
          <td>${escapeHtml(getEditedStatusLabel(entry))}</td>
          <td>${escapeHtml(entry.asset || "இல்லை")}</td>
          <td>${escapeHtml(entry.token || "இல்லை")}</td>
          <td>${escapeHtml(isThaaiMamanEntry(entry) ? "ஆம்" : "இல்லை")}</td>
          <td>${escapeHtml(formatEntryDateTimeTamil(entry.datetime || entry.created_at))}</td>
        </tr>
      `,
    )
    .join("");
}

function buildEntriesTableSectionTamil(title, entries, emptyMessage) {
  const rows = buildEntryTableRowsTamil(entries);

  return `
    <div class="section">
      <div class="section-title">${title}</div>
      <table class="entries-table">
        <thead>
          <tr>
            <th>#</th>
            <th>பெயர்</th>
            <th>குடும்பம்</th>
            <th>மொபைல்</th>
            <th>ஊர்</th>
            <th>நகர்</th>
            <th>மாநிலம்</th>
            <th>வகை</th>
            <th>தொகை</th>
            <th>நோட்டு மொத்தம்</th>
            <th>நோட்டு விவரம்</th>
            <th>மீதி</th>
            <th>Status</th>
            <th>பொருள்</th>
            <th>டோக்கன்</th>
            <th>தாய்மாமன்</th>
            <th>தேதி மற்றும் நேரம்</th>
          </tr>
        </thead>
        <tbody>${rows || `<tr><td colspan="17">${emptyMessage}</td></tr>`}</tbody>
      </table>
    </div>
  `;
}

function buildThaaiMamanEntriesTableHtmlTamil(entries) {
  const thaiEntries = sortEntriesForExport(entries).filter((entry) =>
    isThaaiMamanEntry(entry),
  );

  return buildEntriesTableSectionTamil(
    "தாய்மாமன் பதிவுகள்",
    thaiEntries,
    "தாய்மாமன் பதிவுகள் இல்லை.",
  );
}

function buildEntriesTableHtmlTamil(entries) {
  return buildEntriesTableSectionTamil(
    "அனைத்து பதிவுகள்",
    sortEntriesForExport(entries),
    "பதிவுகள் இல்லை.",
  );
}

function buildOverallDenominationHtmlTamil(entries) {
  const totals = getOverallDenominationCounts(entries);
  const totalReturnAmount = getOverallReturnAmount(entries);
  const rows = Object.entries(totals)
    .map(([note, count]) => ({
      note: parseInt(note, 10) || 0,
      count: parseInt(count, 10) || 0,
    }))
    .filter(({ note, count }) => note > 0 && count > 0)
    .sort((a, b) => b.note - a.note)
    .map(
      ({ note, count }) => `
        <tr>
          <td>${formatCurrencyTamil(note)}</td>
          <td>${Number(count).toLocaleString("ta-IN")}</td>
          <td>${formatCurrencyTamil(note * count)}</td>
        </tr>
      `,
    )
    .join("");

  if (!rows) {
    return `
      <div class="section">
        <div class="section-title">மொத்த நோட்டு விவரம்</div>
        <p>நோட்டு விவரம் இல்லை.</p>
      </div>
    `;
  }

  return `
    <div class="section">
      <div class="section-title">மொத்த நோட்டு விவரம்</div>
      <table class="entries-table">
        <thead>
          <tr>
            <th>நோட்டு</th>
            <th>எண்ணிக்கை</th>
            <th>மொத்தம்</th>
          </tr>
        </thead>
        <tbody>${rows}</tbody>
        <tfoot>
          <tr>
            <td colspan="2"><strong>மீதி மொத்தம்</strong></td>
            <td><strong>${formatCurrencyTamil(totalReturnAmount)}</strong></td>
          </tr>
        </tfoot>
      </table>
    </div>
  `;
}

function buildDisclaimerHtmlTamil() {
  return `
    <div class="disclaimer">
      <strong>எச்சரிக்கை:</strong> இந்த ஆவணத்தில் உள்ள விழா மற்றும் மொய் தகவல்கள் ரகசியமானவை.
      இதை வெளியிட்டால் கடுமையான நடவடிக்கை எடுக்கப்படும்.
    </div>
  `;
}

function buildPdfDocumentHtmlTamil({ eventInfo, entries, stats }) {
  const generatedAt = formatEntryDateTimeTamil(new Date());

  return `
    <!DOCTYPE html>
    <html lang="ta">
      <head>
        <meta charset="UTF-8" />
        <title>மொய் பதிவுகள்</title>
        <style>
          * { box-sizing: border-box; }
          body { font-family: "Noto Sans Tamil", "Latha", "Vijaya", Arial, sans-serif; margin: 0; color: #111827; background: #ffffff; }
          .page { padding: 24px; }
          .page-break { page-break-before: always; }
          .header { border-bottom: 3px solid #111827; padding-bottom: 12px; margin-bottom: 20px; }
          .header h1 { margin: 0 0 6px; font-size: 24px; }
          .header p { margin: 0; color: #4b5563; font-size: 12px; }
          .section { margin-bottom: 20px; }
          .section-title { font-size: 15px; font-weight: 700; margin-bottom: 10px; color: #111827; }
          .meta-table, .entries-table { width: 100%; border-collapse: collapse; }
          .meta-table td, .entries-table th, .entries-table td { border: 1px solid #d1d5db; padding: 8px; font-size: 12px; vertical-align: top; }
          .meta-table td:first-child { width: 32%; font-weight: 700; background: #f9fafb; }
          .entries-table thead th { background: #111827; color: #ffffff; font-size: 11px; text-align: left; }
          .entries-table tbody tr:nth-child(even) { background: #f9fafb; }
          .stats-grid { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 12px; }
          .stat-card { border: 1px solid #d1d5db; border-radius: 10px; padding: 12px; background: #f9fafb; }
          .stat-label { font-size: 11px; color: #6b7280; margin-bottom: 6px; }
          .stat-value { font-size: 18px; font-weight: 700; color: #111827; }
          .disclaimer { margin-top: 16px; padding: 14px 16px; border: 2px solid #dc2626; background: #fef2f2; color: #991b1b; font-size: 12px; line-height: 1.5; border-radius: 10px; }
        </style>
      </head>
      <body>
        <div class="page">
          <div class="header">
            <h1>மொய் பதிவு அறிக்கை</h1>
            <p>உருவாக்கப்பட்ட நேரம்: ${escapeHtml(generatedAt)}</p>
          </div>
          ${buildVendorInfoHtmlTamil(eventInfo)}
          ${buildThaaiMamanSummaryHtmlTamil(stats)}
          ${buildTallyHtmlTamil(stats)}
          ${buildDisclaimerHtmlTamil()}
        </div>

        <div class="page page-break">
          <div class="header">
            <h1>மொய் பதிவு விரிவான பட்டியல்</h1>
            <p>மொத்த பதிவுகள்: ${Number(entries.length).toLocaleString("ta-IN")}</p>
          </div>
          ${buildThaaiMamanEntriesTableHtmlTamil(entries)}
          ${buildEntriesTableHtmlTamil(entries)}
          ${buildOverallDenominationHtmlTamil(entries)}
          ${buildDisclaimerHtmlTamil()}
        </div>
      </body>
    </html>
  `;
}

function buildExcelWorksheetHtmlTamil({ eventInfo, entries, stats }) {
  const vendorName =
    eventInfo?.vendor_name || eventInfo?.vendorName || "Digital Moi Tech";
  const vendorPhone = resolveVendorPhone(eventInfo, vendorName);
  const vendorAddress =
    eventInfo?.vendor_address || eventInfo?.vendorAddress || "இல்லை";
  const customerName = eventInfo?.customer_name || "இல்லை";
  const eventType = eventInfo?.event_type || "இல்லை";
  const eventDate = formatCustomDate(eventInfo?.event_date, "date") || "இல்லை";
  const eventAddress = eventInfo?.event_address || "இல்லை";
  const sortedEntries = sortEntriesForExport(entries);

  const entryRows = sortedEntries
    .map(
      (entry, index) => `
        <tr>
          <td>${Number(index + 1).toLocaleString("ta-IN")}</td>
          <td>${escapeHtml(entry.name || "இல்லை")}</td>
          <td>${escapeHtml(entry.family_name || "இல்லை")}</td>
          <td>${escapeHtml(maskMobileNumber(entry.mobile))}</td>
          <td>${escapeHtml(entry.village || "இல்லை")}</td>
          <td>${escapeHtml(entry.city || "இல்லை")}</td>
          <td>${escapeHtml(entry.state || "இல்லை")}</td>
          <td>${escapeHtml(getTamilAssetTypeLabel(entry.asset_type))}</td>
          <td>${escapeHtml(getExportEntryAmount(entry))}</td>
          <td>${escapeHtml(getEntryDenominationTotal(entry) !== null ? formatCurrencyTamil(getEntryDenominationTotal(entry)) : "இல்லை")}</td>
          <td>${escapeHtml(getEntryDenominationSummary(entry) === "-" ? "இல்லை" : getEntryDenominationSummary(entry))}</td>
          <td>${escapeHtml(getEntryReturnAmount(entry) !== null ? formatCurrencyTamil(getEntryReturnAmount(entry)) : "இல்லை")}</td>
          <td>${escapeHtml(getEditedStatusLabel(entry))}</td>
          <td>${escapeHtml(entry.asset || "இல்லை")}</td>
          <td>${escapeHtml(entry.token || "இல்லை")}</td>
          <td>${escapeHtml(isThaaiMamanEntry(entry) ? "ஆம்" : "இல்லை")}</td>
          <td>${escapeHtml(formatEntryDateTimeTamil(entry.datetime || entry.created_at))}</td>
        </tr>
      `,
    )
    .join("");

  const denominationRows =
    Object.entries(getOverallDenominationCounts(entries))
      .map(([note, count]) => {
        const parsedNote = parseInt(note, 10) || 0;
        const parsedCount = parseInt(count, 10) || 0;
        return parsedNote > 0 && parsedCount > 0
          ? `<tr><td>${escapeHtml(formatCurrencyTamil(parsedNote))}</td><td>${escapeHtml(Number(parsedCount).toLocaleString("ta-IN"))}</td><td>${escapeHtml(formatCurrencyTamil(parsedNote * parsedCount))}</td><td colspan="14"></td></tr>`
          : "";
      })
      .join("") || '<tr><td colspan="17">நோட்டு விவரம் இல்லை.</td></tr>';

  return `
    <html lang="ta" xmlns:o="urn:schemas-microsoft-com:office:office"
          xmlns:x="urn:schemas-microsoft-com:office:excel"
          xmlns="http://www.w3.org/TR/REC-html40">
      <head>
        <meta charset="UTF-8" />
        <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
        <!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>மொய் பதிவுகள்</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]-->
        <style>
          body { font-family: "Noto Sans Tamil", "Latha", "Vijaya", Arial, sans-serif; }
          table { border-collapse: collapse; width: 100%; }
          td, th { border: 1px solid #000; padding: 6px; }
          .title { font-size: 18px; font-weight: bold; background: #dbeafe; }
          .section { font-weight: bold; background: #e5e7eb; }
          .label { font-weight: bold; background: #f3f4f6; width: 220px; }
          .warning { color: #991b1b; background: #fee2e2; font-weight: bold; }
          .thead th { background: #111827; color: #fff; }
        </style>
      </head>
      <body>
        <table>
          <tr><td colspan="16" class="title">மொய் பதிவு ஏற்றுமதி</td></tr>
          <tr><td colspan="16">உருவாக்கப்பட்ட நேரம்: ${escapeHtml(formatEntryDateTimeTamil(new Date()))}</td></tr>

          <tr><td colspan="16" class="section">விசேஷ வீட்டாளர் விவரம்</td></tr>
          <tr><td class="label">விசேஷ வீட்டாளர் பெயர்</td><td colspan="15">${escapeHtml(vendorName)}</td></tr>
          <tr><td class="label">முகவரி</td><td colspan="15">${escapeHtml(vendorAddress)}</td></tr>
          <tr><td class="label">தொலைபேசி</td><td colspan="15">${escapeHtml(vendorPhone)}</td></tr>

          <tr><td colspan="16" class="section">விழா விவரம்</td></tr>
          <tr><td class="label">வாடிக்கையாளர் பெயர்</td><td colspan="15">${escapeHtml(customerName)}</td></tr>
          <tr><td class="label">விழா வகை</td><td colspan="15">${escapeHtml(eventType)}</td></tr>
          <tr><td class="label">விழா தேதி</td><td colspan="15">${escapeHtml(eventDate)}</td></tr>
          <tr><td class="label">விழா முகவரி</td><td colspan="15">${escapeHtml(eventAddress)}</td></tr>

          <tr><td colspan="16" class="section">தாய்மாமன் சிறப்பு சுருக்கம்</td></tr>
          <tr><td class="label">தாய்மாமன் பதிவுகள்</td><td colspan="15">${Number(stats.thaaiMamanCount || 0).toLocaleString("ta-IN")}</td></tr>
          <tr><td class="label">தாய்மாமன் மொத்தம்</td><td colspan="15">${escapeHtml(formatCurrencyTamil(stats.thaaiMamanTotal || 0))}</td></tr>

          <tr><td colspan="16" class="section">மொத்த சுருக்கம்</td></tr>
          <tr><td class="label">மொத்த பதிவுகள்</td><td colspan="15">${Number(stats.totalEntries).toLocaleString("ta-IN")}</td></tr>
          <tr><td class="label">பண மொத்தம்</td><td colspan="15">${escapeHtml(formatCurrencyTamil(stats.totalCash))}</td></tr>
          <tr><td class="label">ஆன்லைன் மொத்தம்</td><td colspan="15">${escapeHtml(formatCurrencyTamil(stats.totalOnline))}</td></tr>
          <tr><td class="label">பணம் மொத்தம்</td><td colspan="15">${escapeHtml(formatCurrencyTamil(stats.totalMonetary))}</td></tr>
          <tr><td class="label">நகை எண்ணிக்கை</td><td colspan="15">${Number(stats.ornamentsCount).toLocaleString("ta-IN")}</td></tr>
          <tr><td class="label">பொருள் எண்ணிக்கை</td><td colspan="15">${Number(stats.thingsCount).toLocaleString("ta-IN")}</td></tr>
          <tr><td colspan="16" class="warning">எச்சரிக்கை: இந்த ஆவணத்தில் உள்ள விழா மற்றும் மொய் தகவல்கள் ரகசியமானவை. இதை வெளியிட்டால் கடுமையான நடவடிக்கை எடுக்கப்படும்.</td></tr>

          <tr><td colspan="16" class="section">தாய்மாமன் பதிவுகள்</td></tr>
          <tr class="thead">
            <th>#</th>
            <th>பெயர்</th>
            <th>குடும்பம்</th>
            <th>மொபைல்</th>
            <th>ஊர்</th>
            <th>நகர்</th>
            <th>மாநிலம்</th>
            <th>வகை</th>
            <th>தொகை</th>
            <th>நோட்டு மொத்தம்</th>
            <th>நோட்டு விவரம்</th>
            <th>மீதி</th>
            <th>Status</th>
            <th>பொருள்</th>
            <th>டோக்கன்</th>
            <th>தாய்மாமன்</th>
            <th>தேதி மற்றும் நேரம்</th>
          </tr>
          ${buildEntryTableRowsTamil(sortedEntries.filter((entry) => isThaaiMamanEntry(entry))) || '<tr><td colspan="17">தாய்மாமன் பதிவுகள் இல்லை.</td></tr>'}

          <tr><td colspan="16" class="section">அனைத்து பதிவுகள்</td></tr>
          <tr class="thead">
            <th>#</th>
            <th>பெயர்</th>
            <th>குடும்பம்</th>
            <th>மொபைல்</th>
            <th>ஊர்</th>
            <th>நகர்</th>
            <th>மாநிலம்</th>
            <th>வகை</th>
            <th>தொகை</th>
            <th>நோட்டு மொத்தம்</th>
            <th>நோட்டு விவரம்</th>
            <th>மீதி</th>
            <th>Status</th>
            <th>பொருள்</th>
            <th>டோக்கன்</th>
            <th>தாய்மாமன்</th>
            <th>தேதி மற்றும் நேரம்</th>
          </tr>
          ${entryRows || '<tr><td colspan="17">பதிவுகள் இல்லை.</td></tr>'}
          <tr><td colspan="16" class="section">மொத்த நோட்டு விவரம்</td></tr>
          <tr class="thead"><th>நோட்டு</th><th>எண்ணிக்கை</th><th>மொத்தம்</th><th colspan="13"></th></tr>
          ${denominationRows}
          <tr><td colspan="2"><strong>மீதி மொத்தம்</strong></td><td><strong>${escapeHtml(formatCurrencyTamil(getOverallReturnAmount(entries)))}</strong></td><td colspan="13"></td></tr>
          <tr><td colspan="16" class="warning">எச்சரிக்கை: இந்த ஆவணத்தில் உள்ள விழா மற்றும் மொய் தகவல்கள் ரகசியமானவை. இதை வெளியிட்டால் கடுமையான நடவடிக்கை எடுக்கப்படும்.</td></tr>
        </table>
      </body>
    </html>
  `;
}

function buildEntryTableRowsTamilAudit(entries) {
  return entries
    .map(
      (entry, index) => `
        <tr>
          <td>${Number(index + 1).toLocaleString("ta-IN")}</td>
          <td>${escapeHtml(entry.name || "à®‡à®²à¯à®²à¯ˆ")}</td>
          <td>${escapeHtml(entry.family_name || "à®‡à®²à¯à®²à¯ˆ")}</td>
          <td>${escapeHtml(maskMobileNumber(entry.mobile))}</td>
          <td>${escapeHtml(entry.village || "à®‡à®²à¯à®²à¯ˆ")}</td>
          <td>${escapeHtml(entry.city || "à®‡à®²à¯à®²à¯ˆ")}</td>
          <td>${escapeHtml(entry.state || "à®‡à®²à¯à®²à¯ˆ")}</td>
          <td>${escapeHtml(getTamilAssetTypeLabel(entry.asset_type))}</td>
          <td>${getExportEntryAmount(entry)}</td>
          <td>${getEntryDenominationTotal(entry) !== null ? formatCurrencyTamil(getEntryDenominationTotal(entry)) : "à®‡à®²à¯à®²à¯ˆ"}</td>
          <td>${escapeHtml(getEntryDenominationSummary(entry) === "-" ? "à®‡à®²à¯à®²à¯ˆ" : getEntryDenominationSummary(entry))}</td>
          <td>${getEntryReturnAmount(entry) !== null ? formatCurrencyTamil(getEntryReturnAmount(entry)) : "à®‡à®²à¯à®²à¯ˆ"}</td>
          <td>${escapeHtml(getEditedStatusLabel(entry))}</td>
          <td>${escapeHtml(entry.asset || "à®‡à®²à¯à®²à¯ˆ")}</td>
          <td>${escapeHtml(entry.token || "à®‡à®²à¯à®²à¯ˆ")}</td>
          <td>${escapeHtml(isThaaiMamanEntry(entry) ? "à®†à®®à¯" : "à®‡à®²à¯à®²à¯ˆ")}</td>
          <td>${escapeHtml(formatEntryDateTimeTamil(entry.datetime || entry.created_at))}</td>
        </tr>
      `,
    )
    .join("");
}

function buildEntriesTableSectionTamilAudit(title, entries, emptyMessage) {
  const rows = buildEntryTableRowsTamilAudit(entries);

  return `
    <div class="section">
      <div class="section-title">${title}</div>
      <table class="entries-table">
        <thead>
          <tr>
            <th>#</th>
            <th>à®ªà¯†à®¯à®°à¯</th>
            <th>à®•à¯à®Ÿà¯à®®à¯à®ªà®®à¯</th>
            <th>à®®à¯Šà®ªà¯ˆà®²à¯</th>
            <th>à®Šà®°à¯</th>
            <th>à®¨à®•à®°à¯</th>
            <th>à®®à®¾à®¨à®¿à®²à®®à¯</th>
            <th>à®µà®•à¯ˆ</th>
            <th>à®¤à¯Šà®•à¯ˆ</th>
            <th>à®¨à¯‹à®Ÿà¯à®Ÿà¯ à®®à¯Šà®¤à¯à®¤à®®à¯</th>
            <th>à®¨à¯‹à®Ÿà¯à®Ÿà¯ à®µà®¿à®µà®°à®®à¯</th>
            <th>à®®à¯€à®¤à®¿</th>
            <th>Status</th>
            <th>à®ªà¯Šà®°à¯à®³à¯</th>
            <th>à®Ÿà¯‹à®•à¯à®•à®©à¯</th>
            <th>à®¤à®¾à®¯à¯à®®à®¾à®®à®©à¯</th>
            <th>à®¤à¯‡à®¤à®¿ à®®à®±à¯à®±à¯à®®à¯ à®¨à¯‡à®°à®®à¯</th>
          </tr>
        </thead>
        <tbody>${rows || `<tr><td colspan="17">${emptyMessage}</td></tr>`}</tbody>
      </table>
    </div>
  `;
}

function buildThaaiMamanEntriesTableHtmlTamilAudit(entries) {
  const thaiEntries = sortEntriesForExport(entries).filter((entry) =>
    isThaaiMamanEntry(entry),
  );

  return buildEntriesTableSectionTamilAudit(
    "à®¤à®¾à®¯à¯à®®à®¾à®®à®©à¯ à®ªà®¤à®¿à®µà¯à®•à®³à¯",
    thaiEntries,
    "à®¤à®¾à®¯à¯à®®à®¾à®®à®©à¯ à®ªà®¤à®¿à®µà¯à®•à®³à¯ à®‡à®²à¯à®²à¯ˆ.",
  );
}

function buildEntriesTableHtmlTamilAudit(entries) {
  return buildEntriesTableSectionTamilAudit(
    "à®…à®©à¯ˆà®¤à¯à®¤à¯ à®ªà®¤à®¿à®µà¯à®•à®³à¯",
    sortEntriesForExport(entries),
    "à®ªà®¤à®¿à®µà¯à®•à®³à¯ à®‡à®²à¯à®²à¯ˆ.",
  );
}

function buildPdfDocumentHtmlTamilAudit({ eventInfo, entries, stats }) {
  const generatedAt = formatEntryDateTimeTamil(new Date());

  return `
    <!DOCTYPE html>
    <html lang="ta">
      <head>
        <meta charset="UTF-8" />
        <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
        <title>à®®à¯Šà®¯à¯ à®ªà®¤à®¿à®µà¯à®•à®³à¯</title>
        <style>
          * { box-sizing: border-box; }
          body { font-family: "Noto Sans Tamil", "Latha", "Vijaya", Arial, sans-serif; margin: 0; color: #111827; background: #ffffff; }
          .page { padding: 24px; }
          .page-break { page-break-before: always; }
          .header { border-bottom: 3px solid #111827; padding-bottom: 12px; margin-bottom: 20px; }
          .header h1 { margin: 0 0 6px; font-size: 24px; }
          .header p { margin: 0; color: #4b5563; font-size: 12px; }
          .section { margin-bottom: 20px; }
          .section-title { font-size: 15px; font-weight: 700; margin-bottom: 10px; color: #111827; }
          .meta-table, .entries-table { width: 100%; border-collapse: collapse; }
          .meta-table td, .entries-table th, .entries-table td { border: 1px solid #d1d5db; padding: 8px; font-size: 12px; vertical-align: top; }
          .meta-table td:first-child { width: 32%; font-weight: 700; background: #f9fafb; }
          .entries-table thead th { background: #111827; color: #ffffff; font-size: 11px; text-align: left; }
          .entries-table tbody tr:nth-child(even) { background: #f9fafb; }
          .stats-grid { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 12px; }
          .stat-card { border: 1px solid #d1d5db; border-radius: 10px; padding: 12px; background: #f9fafb; }
          .stat-label { font-size: 11px; color: #6b7280; margin-bottom: 6px; }
          .stat-value { font-size: 18px; font-weight: 700; color: #111827; }
          .disclaimer { margin-top: 16px; padding: 14px 16px; border: 2px solid #dc2626; background: #fef2f2; color: #991b1b; font-size: 12px; line-height: 1.5; border-radius: 10px; }
        </style>
      </head>
      <body>
        <div class="page">
          <div class="header">
            <h1>à®®à¯Šà®¯à¯ à®ªà®¤à®¿à®µà¯ à®…à®±à®¿à®•à¯à®•à¯ˆ</h1>
            <p>à®‰à®°à¯à®µà®¾à®•à¯à®•à®ªà¯à®ªà®Ÿà¯à®Ÿ à®¨à¯‡à®°à®®à¯: ${escapeHtml(generatedAt)}</p>
          </div>
          ${buildVendorInfoHtmlTamil(eventInfo)}
          ${buildThaaiMamanSummaryHtmlTamil(stats)}
          ${buildTallyHtmlTamil(stats)}
          ${buildDisclaimerHtmlTamil()}
        </div>

        <div class="page page-break">
          <div class="header">
            <h1>à®®à¯Šà®¯à¯ à®ªà®¤à®¿à®µà¯ à®µà®¿à®°à®¿à®µà®¾à®© à®ªà®Ÿà¯à®Ÿà®¿à®¯à®²à¯</h1>
            <p>à®®à¯Šà®¤à¯à®¤ à®ªà®¤à®¿à®µà¯à®•à®³à¯: ${Number(entries.length).toLocaleString("ta-IN")}</p>
          </div>
          ${buildThaaiMamanEntriesTableHtmlTamilAudit(entries)}
          ${buildEntriesTableHtmlTamilAudit(entries)}
          ${buildOverallDenominationHtmlTamil(entries)}
          ${buildDisclaimerHtmlTamil()}
        </div>
      </body>
    </html>
  `;
}

function buildExcelWorksheetHtmlTamilAudit({ eventInfo, entries, stats }) {
  const vendorName =
    eventInfo?.vendor_name || eventInfo?.vendorName || "Digital Moi Tech";
  const vendorPhone = resolveVendorPhone(eventInfo, vendorName);
  const vendorAddress =
    eventInfo?.vendor_address || eventInfo?.vendorAddress || "à®‡à®²à¯à®²à¯ˆ";
  const customerName = eventInfo?.customer_name || "à®‡à®²à¯à®²à¯ˆ";
  const eventType = eventInfo?.event_type || "à®‡à®²à¯à®²à¯ˆ";
  const eventDate = formatCustomDate(eventInfo?.event_date, "date") || "à®‡à®²à¯à®²à¯ˆ";
  const eventAddress = eventInfo?.event_address || "à®‡à®²à¯à®²à¯ˆ";
  const sortedEntries = sortEntriesForExport(entries);

  const entryRows = sortedEntries
    .map(
      (entry, index) => `
        <tr>
          <td>${Number(index + 1).toLocaleString("ta-IN")}</td>
          <td>${escapeHtml(entry.name || "à®‡à®²à¯à®²à¯ˆ")}</td>
          <td>${escapeHtml(entry.family_name || "à®‡à®²à¯à®²à¯ˆ")}</td>
          <td>${escapeHtml(maskMobileNumber(entry.mobile))}</td>
          <td>${escapeHtml(entry.village || "à®‡à®²à¯à®²à¯ˆ")}</td>
          <td>${escapeHtml(entry.city || "à®‡à®²à¯à®²à¯ˆ")}</td>
          <td>${escapeHtml(entry.state || "à®‡à®²à¯à®²à¯ˆ")}</td>
          <td>${escapeHtml(getTamilAssetTypeLabel(entry.asset_type))}</td>
          <td>${escapeHtml(getExportEntryAmount(entry))}</td>
          <td>${escapeHtml(getEntryDenominationTotal(entry) !== null ? formatCurrencyTamil(getEntryDenominationTotal(entry)) : "à®‡à®²à¯à®²à¯ˆ")}</td>
          <td>${escapeHtml(getEntryDenominationSummary(entry) === "-" ? "à®‡à®²à¯à®²à¯ˆ" : getEntryDenominationSummary(entry))}</td>
          <td>${escapeHtml(getEntryReturnAmount(entry) !== null ? formatCurrencyTamil(getEntryReturnAmount(entry)) : "à®‡à®²à¯à®²à¯ˆ")}</td>
          <td>${escapeHtml(getEditedStatusLabel(entry))}</td>
          <td>${escapeHtml(entry.asset || "à®‡à®²à¯à®²à¯ˆ")}</td>
          <td>${escapeHtml(entry.token || "à®‡à®²à¯à®²à¯ˆ")}</td>
          <td>${escapeHtml(isThaaiMamanEntry(entry) ? "à®†à®®à¯" : "à®‡à®²à¯à®²à¯ˆ")}</td>
          <td>${escapeHtml(formatEntryDateTimeTamil(entry.datetime || entry.created_at))}</td>
        </tr>
      `,
    )
    .join("");

  const denominationRows =
    Object.entries(getOverallDenominationCounts(entries))
      .map(([note, count]) => {
        const parsedNote = parseInt(note, 10) || 0;
        const parsedCount = parseInt(count, 10) || 0;
        return parsedNote > 0 && parsedCount > 0
          ? `<tr><td>${escapeHtml(formatCurrencyTamil(parsedNote))}</td><td>${escapeHtml(Number(parsedCount).toLocaleString("ta-IN"))}</td><td>${escapeHtml(formatCurrencyTamil(parsedNote * parsedCount))}</td><td colspan="14"></td></tr>`
          : "";
      })
      .join("") || '<tr><td colspan="17">à®¨à¯‹à®Ÿà¯à®Ÿà¯ à®µà®¿à®µà®°à®®à¯ à®‡à®²à¯à®²à¯ˆ.</td></tr>';

  return `
    <html lang="ta" xmlns:o="urn:schemas-microsoft-com:office:office"
          xmlns:x="urn:schemas-microsoft-com:office:excel"
          xmlns="http://www.w3.org/TR/REC-html40">
      <head>
        <meta charset="UTF-8" />
        <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
        <!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>à®®à¯Šà®¯à¯ à®ªà®¤à®¿à®µà¯à®•à®³à¯</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]-->
        <style>
          body { font-family: "Noto Sans Tamil", "Latha", "Vijaya", Arial, sans-serif; }
          body { font-family: "Noto Sans Tamil", "Latha", "Vijaya", Arial, sans-serif; }
          table { border-collapse: collapse; width: 100%; }
          td, th { border: 1px solid #000; padding: 6px; }
          .title { font-size: 18px; font-weight: bold; background: #dbeafe; }
          .section { font-weight: bold; background: #e5e7eb; }
          .label { font-weight: bold; background: #f3f4f6; width: 220px; }
          .warning { color: #991b1b; background: #fee2e2; font-weight: bold; }
          .thead th { background: #111827; color: #fff; }
        </style>
      </head>
      <body>
        <table>
          <tr><td colspan="17" class="title">à®®à¯Šà®¯à¯ à®ªà®¤à®¿à®µà¯ à®…à®±à®¿à®•à¯à®•à¯ˆ</td></tr>
          <tr><td class="label">Vendor Name</td><td colspan="16">${escapeHtml(vendorName)}</td></tr>
          <tr><td class="label">Vendor Phone</td><td colspan="16">${escapeHtml(vendorPhone)}</td></tr>
          <tr><td class="label">Vendor Address</td><td colspan="16">${escapeHtml(vendorAddress)}</td></tr>
          <tr><td class="label">Customer Name</td><td colspan="16">${escapeHtml(customerName)}</td></tr>
          <tr><td class="label">Event Type</td><td colspan="16">${escapeHtml(eventType)}</td></tr>
          <tr><td class="label">Event Date</td><td colspan="16">${escapeHtml(eventDate)}</td></tr>
          <tr><td class="label">Event Address</td><td colspan="16">${escapeHtml(eventAddress)}</td></tr>

          <tr><td colspan="17" class="section">Total Tally Info</td></tr>
          <tr><td class="label">Total Entries</td><td colspan="16">${stats.totalEntries}</td></tr>
          <tr><td class="label">Cash Total</td><td colspan="16">${escapeHtml(stats.totalCash)}</td></tr>
          <tr><td class="label">Online Total</td><td colspan="16">${escapeHtml(stats.totalOnline)}</td></tr>
          <tr><td class="label">Money Total</td><td colspan="16">${escapeHtml(stats.totalMonetary)}</td></tr>
          <tr><td class="label">Ornaments Count</td><td colspan="16">${stats.ornamentsCount}</td></tr>
          <tr><td class="label">Things Count</td><td colspan="16">${stats.thingsCount}</td></tr>
          <tr><td colspan="17" class="warning">Disclaimer: This document contains confidential event and contribution data. If you leak this data, it will lead to severe action.</td></tr>

          <tr><td colspan="17" class="section">Entry Details</td></tr>
          <tr class="thead">
            <th>#</th>
            <th>Name</th>
            <th>Family</th>
            <th>Mobile</th>
            <th>Village</th>
            <th>City</th>
            <th>State</th>
            <th>Type</th>
            <th>Amount</th>
            <th>Denom Total</th>
            <th>Denomination</th>
            <th>Return</th>
            <th>Status</th>
            <th>Asset</th>
            <th>Token</th>
            <th>Thaai Maman</th>
            <th>Date & Time</th>
          </tr>
          ${entryRows || '<tr><td colspan="17">No entries available</td></tr>'}
          <tr><td colspan="17" class="section">Overall Denomination Summary</td></tr>
          <tr class="thead"><th>Note</th><th>Total Count</th><th>Total Received</th><th colspan="14"></th></tr>
          ${denominationRows}
          <tr><td colspan="2"><strong>Total Return Amount</strong></td><td><strong>${escapeHtml(String(getOverallReturnAmount(entries)))}</strong></td><td colspan="14"></td></tr>
          <tr><td colspan="17" class="warning">Disclaimer: This document contains confidential event and contribution data. If you leak this data, it will lead to severe action.</td></tr>
        </table>
      </body>
    </html>
  `;
}

function buildPdfDocumentHtml({ eventInfo, entries, stats }) {
  const generatedAt = formatEntryDateTime(new Date());

  return `
    <!DOCTYPE html>
    <html>
      <head>
        <meta charset="UTF-8" />
        <title>Moi Entries Export</title>
        <style>
          * { box-sizing: border-box; }
          body {
            font-family: Arial, sans-serif;
            margin: 0;
            color: #111827;
            background: #ffffff;
          }
          .page {
            padding: 24px;
          }
          .page-break {
            page-break-before: always;
          }
          .header {
            border-bottom: 3px solid #111827;
            padding-bottom: 12px;
            margin-bottom: 20px;
          }
          .header h1 {
            margin: 0 0 6px;
            font-size: 24px;
          }
          .header p {
            margin: 0;
            color: #4b5563;
            font-size: 12px;
          }
          .section {
            margin-bottom: 20px;
          }
          .section-title {
            font-size: 15px;
            font-weight: 700;
            margin-bottom: 10px;
            color: #111827;
            text-transform: uppercase;
            letter-spacing: 0.04em;
          }
          .meta-table, .entries-table {
            width: 100%;
            border-collapse: collapse;
          }
          .meta-table td, .entries-table th, .entries-table td {
            border: 1px solid #d1d5db;
            padding: 8px;
            font-size: 12px;
            vertical-align: top;
          }
          .meta-table td:first-child {
            width: 32%;
            font-weight: 700;
            background: #f9fafb;
          }
          .entries-table thead th {
            background: #111827;
            color: #ffffff;
            font-size: 11px;
            text-align: left;
          }
          .entries-table tbody tr:nth-child(even) {
            background: #f9fafb;
          }
          .stats-grid {
            display: grid;
            grid-template-columns: repeat(3, minmax(0, 1fr));
            gap: 12px;
          }
          .stat-card {
            border: 1px solid #d1d5db;
            border-radius: 10px;
            padding: 12px;
            background: #f9fafb;
          }
          .stat-label {
            font-size: 11px;
            text-transform: uppercase;
            color: #6b7280;
            margin-bottom: 6px;
          }
          .stat-value {
            font-size: 18px;
            font-weight: 700;
            color: #111827;
          }
          .disclaimer {
            margin-top: 16px;
            padding: 14px 16px;
            border: 2px solid #dc2626;
            background: #fef2f2;
            color: #991b1b;
            font-size: 12px;
            line-height: 1.5;
            border-radius: 10px;
          }
          @media print {
            .page {
              padding: 16px;
            }
          }
        </style>
      </head>
      <body>
        <div class="page">
          <div class="header">
            <h1>Moi Entries Report</h1>
            <p>Generated on ${escapeHtml(generatedAt)}</p>
          </div>
          ${buildVendorInfoHtml(eventInfo)}
          ${buildTallyHtml(stats)}
          ${buildDisclaimerHtml()}
        </div>

        <div class="page page-break">
          <div class="header">
            <h1>Moi Entries Report - Detailed Entries</h1>
            <p>Total records: ${entries.length}</p>
          </div>
          ${buildEntriesTableHtml(entries)}
          ${buildOverallDenominationHtml(entries)}
          ${buildDisclaimerHtml()}
        </div>
      </body>
    </html>
  `;
}

function buildExcelWorksheetHtml({ eventInfo, entries, stats }) {
  const vendorName =
    eventInfo?.vendor_name || eventInfo?.vendorName || "Digital Moi Tech";
  const vendorPhone = resolveVendorPhone(eventInfo, vendorName);
  const vendorAddress =
    eventInfo?.vendor_address || eventInfo?.vendorAddress || "—";
  const customerName = eventInfo?.customer_name || "—";
  const eventType = eventInfo?.event_type || "—";
  const eventDate = formatCustomDate(eventInfo?.event_date, "date") || "—";
  const eventAddress = eventInfo?.event_address || "—";

  const entryRows = entries
    .map(
      (entry, index) => `
        <tr>
          <td>${index + 1}</td>
          <td>${escapeHtml(entry.name || "—")}</td>
          <td>${escapeHtml(entry.family_name || "—")}</td>
          <td>${escapeHtml(maskMobileNumber(entry.mobile))}</td>
          <td>${escapeHtml(entry.village || "—")}</td>
          <td>${escapeHtml(entry.city || "—")}</td>
          <td>${escapeHtml(entry.state || "—")}</td>
          <td>${escapeHtml(entry.asset_type || "—")}</td>
          <td>${escapeHtml(entry.amount || 0)}</td>
          <td>${escapeHtml(getEntryDenominationTotal(entry) !== null ? String(getEntryDenominationTotal(entry)) : "-")}</td>
          <td>${escapeHtml(getEntryDenominationSummary(entry))}</td>
          <td>${escapeHtml(getEntryReturnAmount(entry) !== null ? String(getEntryReturnAmount(entry)) : "-")}</td>
          <td>${escapeHtml(entry.asset || "—")}</td>
          <td>${escapeHtml(entry.token || "—")}</td>
          <td>${escapeHtml(formatEntryDateTime(entry.datetime || entry.created_at))}</td>
        </tr>
      `,
    )
    .join("");

  return `
    <html xmlns:o="urn:schemas-microsoft-com:office:office"
          xmlns:x="urn:schemas-microsoft-com:office:excel"
          xmlns="http://www.w3.org/TR/REC-html40">
      <head>
        <meta charset="UTF-8" />
        <!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>Moi Entries</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]-->
        <style>
          table { border-collapse: collapse; width: 100%; }
          td, th { border: 1px solid #000; padding: 6px; }
          .title { font-size: 18px; font-weight: bold; background: #dbeafe; }
          .section { font-weight: bold; background: #e5e7eb; }
          .label { font-weight: bold; background: #f3f4f6; width: 220px; }
          .warning { color: #991b1b; background: #fee2e2; font-weight: bold; }
          .thead th { background: #111827; color: #fff; }
        </style>
      </head>
      <body>
        <table>
          <tr><td colspan="15" class="title">Moi Entries Export</td></tr>
          <tr><td colspan="15">Generated on ${escapeHtml(formatEntryDateTime(new Date()))}</td></tr>

          <tr><td colspan="15" class="section">Vendor Details</td></tr>
          <tr><td class="label">Vendor Name</td><td colspan="14">${escapeHtml(vendorName)}</td></tr>
          <tr><td class="label">Vendor Address</td><td colspan="14">${escapeHtml(vendorAddress)}</td></tr>
          <tr><td class="label">Vendor Phone</td><td colspan="14">${escapeHtml(vendorPhone)}</td></tr>

          <tr><td colspan="15" class="section">Event Details</td></tr>
          <tr><td class="label">Customer Name</td><td colspan="14">${escapeHtml(customerName)}</td></tr>
          <tr><td class="label">Event Type</td><td colspan="14">${escapeHtml(eventType)}</td></tr>
          <tr><td class="label">Event Date</td><td colspan="14">${escapeHtml(eventDate)}</td></tr>
          <tr><td class="label">Event Address</td><td colspan="14">${escapeHtml(eventAddress)}</td></tr>

          <tr><td colspan="15" class="section">Total Tally Info</td></tr>
          <tr><td class="label">Total Entries</td><td colspan="14">${stats.totalEntries}</td></tr>
          <tr><td class="label">Cash Total</td><td colspan="14">${escapeHtml(stats.totalCash)}</td></tr>
          <tr><td class="label">Online Total</td><td colspan="14">${escapeHtml(stats.totalOnline)}</td></tr>
          <tr><td class="label">Money Total</td><td colspan="14">${escapeHtml(stats.totalMonetary)}</td></tr>
          <tr><td class="label">Ornaments Count</td><td colspan="14">${stats.ornamentsCount}</td></tr>
          <tr><td class="label">Things Count</td><td colspan="14">${stats.thingsCount}</td></tr>
          <tr><td colspan="15" class="warning">Disclaimer: This document contains confidential event and contribution data. If you leak this data, it will lead to severe action.</td></tr>

          <tr><td colspan="15" class="section">Entry Details</td></tr>
          <tr class="thead">
            <th>#</th>
            <th>Name</th>
            <th>Family</th>
            <th>Mobile</th>
            <th>Village</th>
            <th>City</th>
            <th>State</th>
            <th>Type</th>
            <th>Amount</th>
            <th>Denom Total</th>
            <th>Denomination</th>
            <th>Return</th>
            <th>Asset</th>
            <th>Token</th>
            <th>Date & Time</th>
          </tr>
          ${entryRows || '<tr><td colspan="15">No entries available</td></tr>'}
          <tr><td colspan="15" class="section">Overall Denomination Summary</td></tr>
          <tr class="thead"><th>Note</th><th>Total Count</th><th>Total Received</th><th colspan="12"></th></tr>
          ${Object.entries(getOverallDenominationCounts(entries))
      .map(([note, count]) => {
        const parsedNote = parseInt(note, 10) || 0;
        const parsedCount = parseInt(count, 10) || 0;
        return parsedNote > 0 && parsedCount > 0
          ? `<tr><td>${escapeHtml(String(parsedNote))}</td><td>${escapeHtml(String(parsedCount))}</td><td>${escapeHtml(String(parsedNote * parsedCount))}</td><td colspan="12"></td></tr>`
          : "";
      })
      .join("") ||
    '<tr><td colspan="15">No denomination data available</td></tr>'
    }
          <tr><td colspan="2"><strong>Total Return Amount</strong></td><td><strong>${escapeHtml(String(getOverallReturnAmount(entries)))}</strong></td><td colspan="12"></td></tr>
          <tr><td colspan="15" class="warning">Disclaimer: This document contains confidential event and contribution data. If you leak this data, it will lead to severe action.</td></tr>
        </table>
      </body>
    </html>
  `;
}

// ─── Flash helper ─────────────────────────────────────────────────────────────
function flashEl(el, classes, ms = 600) {
  if (!el) return;
  el.classList.add(...classes);
  setTimeout(() => el?.classList.remove(...classes), ms);
}

// ─── Entry Card ───────────────────────────────────────────────────────────────
function EntryCard({
  entry,
  isNew,
  isEditing,
  onEdit,
  onToggleThaaiMaman,
  isThaaiMamanUpdating,
}) {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 20);
    return () => clearTimeout(t);
  }, []);

  const cfg = ASSET_CONFIG[entry.asset_type] || {
    label: entry.asset_type,
    icon: "📦",
    color: "bg-gray-100 text-gray-700 border-gray-200",
  };
  const isCash = entry.asset_type === "cash" || entry.asset_type === "online";
  const isThaaiMamanChecked =
    entry.thaai_maman === true ||
    entry.thaai_maman === 1 ||
    entry.thaai_maman === "1";

  const receiptNumber =
    entry.receipt_no || entry.token || entry.entry_id || entry.id;

  const formatTime = (dt) => {
    if (!dt) return "";
    return new Date(dt).toLocaleTimeString("en-IN", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  return (
    <div
      style={{
        opacity: visible ? 1 : 0,
        transform: visible ? "translateX(0)" : "translateX(20px)",
        transition: "opacity 0.3s ease, transform 0.3s ease",
      }}
      className={`border rounded-xl px-3 py-2.5 transition-colors duration-300 ${isNew
          ? "bg-emerald-900/40 border-emerald-700/60"
          : "bg-gray-900 border-gray-800 hover:bg-gray-800"
        }`}
    >
      <div className="flex items-start justify-between gap-2">
        <div className="min-w-0 flex-1">
          <div className="flex items-center gap-1.5 mb-1">
            {receiptNumber && (
              <span
                className="inline-flex items-center px-1.5 py-0.5 rounded text-[11px] font-mono font-black bg-gray-800 text-emerald-400 border border-gray-700/80 shrink-0 shadow-sm"
                title={`Receipt #${receiptNumber}`}
              >
                #{receiptNumber}
              </span>
            )}
            <p className="text-sm font-semibold text-white truncate leading-tight">
              {entry.name}
              {entry.family_name && (
                <span className="text-gray-500 font-normal">
                  {" "}
                  · {entry.family_name}
                </span>
              )}
            </p>
          </div>
          <p className="text-xs text-gray-500 mt-0.5 truncate">
            {[entry.village, entry.area, entry.city].filter(Boolean).join(", ")}
            {entry.mobile ? ` · ${entry.mobile}` : ""}
            {entry.token && String(entry.token) !== String(receiptNumber)
              ? ` · Token: ${entry.token}`
              : ""}
          </p>
        </div>
        <div className="text-right shrink-0">
          <div className="flex items-start justify-end gap-2">
            <button
              type="button"
              onClick={() => onEdit?.(entry)}
              className={`inline-flex h-8 w-8 items-center justify-center rounded-lg border transition ${isEditing
                  ? "border-sky-400 bg-sky-500/20 text-sky-200"
                  : "border-gray-700 bg-gray-800 text-gray-300 hover:border-sky-500 hover:text-sky-300"
                }`}
              title="Edit entry"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                className="h-4 w-4"
              >
                <path d="M16.862 3.487a2.25 2.25 0 1 1 3.182 3.182L8.52 18.193a4.5 4.5 0 0 1-1.897 1.13l-2.685.895a.75.75 0 0 1-.949-.949l.895-2.685a4.5 4.5 0 0 1 1.13-1.897L16.862 3.487Z" />
              </svg>
            </button>
            <div>
              {isCash ? (
                <p className="text-sm font-bold text-emerald-400">
                  {getScreenEntryAmount(entry)}
                </p>
              ) : (
                <p className="text-sm font-semibold text-amber-400 max-w-[80px] truncate">
                  {entry.asset || cfg.label}
                </p>
              )}
              <p className="text-xs text-gray-600 mt-0.5">
                {formatTime(getEntryDateTime(entry))}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="mt-1.5 flex items-center gap-2">
        <span
          className={`inline-flex items-center gap-1 text-xs px-2 py-0.5 rounded-full border font-medium ${cfg.color}`}
        >
          {cfg.icon} {cfg.label}
        </span>
        {isNew && (
          <span className="text-xs font-semibold text-emerald-400 animate-pulse">
            ✓ Just added
          </span>
        )}
        {isEditedEntry(entry) && (
          <span className="text-xs font-semibold text-amber-300 bg-amber-500/10 border border-amber-500/30 px-2 py-0.5 rounded-full">
            Edited Entry
          </span>
        )}
        {isEditing && (
          <span className="text-xs font-semibold text-sky-300 bg-sky-500/10 border border-sky-500/30 px-2 py-0.5 rounded-full">
            Editing Now
          </span>
        )}
      </div>
      <label className="mt-2.5 flex items-center justify-between gap-3 rounded-lg border border-gray-800 bg-gray-950/70 px-3 py-2">
        <span className="text-xs font-semibold text-gray-300">Thaai Maman</span>
        <div className="flex items-center gap-2">
          {isThaaiMamanUpdating && (
            <span className="text-[11px] font-medium text-gray-500">
              Saving...
            </span>
          )}
          <input
            type="checkbox"
            checked={isThaaiMamanChecked}
            disabled={isThaaiMamanUpdating}
            onChange={(e) => onToggleThaaiMaman?.(entry, e.target.checked)}
            className="h-4 w-4 rounded border-gray-600 bg-gray-800 text-emerald-500 focus:ring-emerald-500 disabled:cursor-not-allowed disabled:opacity-60"
          />
        </div>
      </label>
    </div>
  );
}

// ─── Live Entries Panel (right) ───────────────────────────────────────────────
function RunningList({
  entries,
  loading,
  flashMessage,
  onToggleThaaiMaman,
  thaaiMamanUpdatingIds,
  onEditEntry,
  editingEntryId,
  onClose,
}) {
  const totalCash = entries
    .filter((e) => e.asset_type === "cash" || e.asset_type === "online")
    .reduce((s, e) => s + (parseFloat(e.amount) || 0), 0);
  const totalAssetGifts = entries.filter(
    (e) => e.asset_type === "ornaments" || e.asset_type === "things",
  ).length;
  const hasMonetaryEntries = entries.some(
    (e) =>
      (e.asset_type === "cash" || e.asset_type === "online") &&
      e.amount !== null &&
      e.amount !== undefined &&
      e.amount !== "",
  );

  return (
    <div className="flex flex-col h-full bg-gray-950 text-white rounded-2xl overflow-hidden shadow-2xl border border-gray-800">
      <div className="px-4 py-3 border-b border-gray-800 shrink-0">
        <div className="flex items-center justify-between mb-2.5">
          <div>
            <h2 className="text-sm font-bold tracking-wide text-white">
              Live Entries
            </h2>
            <p className="text-xs text-gray-500 mt-0.5">Refreshes on submit</p>
          </div>
          <div className="flex items-center gap-1.5">
            <span className="w-2 h-2 rounded-full bg-emerald-400 animate-pulse" />
            <span className="text-xs text-emerald-400 font-medium">
              {entries.length} entries
            </span>
            {onClose && (
              <button type="button" onClick={onClose} className="ml-2 text-gray-400 hover:text-white p-1 rounded hover:bg-gray-800 transition">
                <FaChevronRight size={12} />
              </button>
            )}
          </div>
        </div>
        <div className="grid grid-cols-2 gap-2">
          <div className="bg-gray-900 border border-gray-800 rounded-xl px-3 py-2 text-center">
            <p className="text-xs text-gray-500 uppercase tracking-wide">
              Total Cash
            </p>
            <p className="text-base font-bold text-emerald-400 mt-0.5">
              {hasMonetaryEntries ? formatCurrency(totalCash) : "-"}
            </p>
          </div>
          <div className="bg-gray-900 border border-gray-800 rounded-xl px-3 py-2 text-center">
            <p className="text-xs text-gray-500 uppercase tracking-wide">
              Asset Gifts
            </p>
            <p className="text-base font-bold text-amber-400 mt-0.5">
              {totalAssetGifts > 0 ? totalAssetGifts : "-"}
            </p>
          </div>
        </div>
      </div>

      {/* Flash banner */}
      <div
        style={{
          maxHeight: flashMessage ? "44px" : "0px",
          opacity: flashMessage ? 1 : 0,
          transition: "max-height 0.3s ease, opacity 0.3s ease",
        }}
        className="overflow-hidden bg-emerald-600 shrink-0"
      >
        <div className="flex items-center justify-center gap-2 px-4 py-2.5">
          <span className="text-white text-sm font-semibold">
            ✓ {flashMessage}
          </span>
        </div>
      </div>

      <div className="flex-1 overflow-y-auto px-3 py-3 space-y-2">
        {loading ? (
          Array.from({ length: 5 }).map((_, i) => (
            <div
              key={i}
              className="bg-gray-900 rounded-xl px-3 py-3 animate-pulse"
            >
              <div className="flex justify-between mb-2">
                <div className="h-3 bg-gray-800 rounded w-1/3" />
                <div className="h-3 bg-gray-800 rounded w-1/5" />
              </div>
              <div className="h-2.5 bg-gray-800 rounded w-2/3" />
            </div>
          ))
        ) : entries.length === 0 ? (
          <div className="flex flex-col items-center justify-center h-full text-gray-600 py-16">
            <span className="text-4xl mb-3">📋</span>
            <p className="text-sm font-medium">No entries yet</p>
            <p className="text-xs mt-1">Submissions will appear here</p>
          </div>
        ) : (
          [...entries]
            .map((entry, i) => (
              <EntryCard
                key={entry.entry_id || `${entry.mobile}-${i}`}
                entry={entry}
                isNew={i === 0}
                isEditing={editingEntryId === entry.entry_id}
                onEdit={onEditEntry}
                onToggleThaaiMaman={onToggleThaaiMaman}
                isThaaiMamanUpdating={thaaiMamanUpdatingIds.includes(
                  entry.entry_id,
                )}
              />
            ))
        )}
      </div>
    </div>
  );
}

// ─── Denomination Panel (left) ────────────────────────────────────────────────
function DenominationPanel({
  denomCounts,
  setDenomCounts,
  denomTotal,
  hasError,
  isCash,
  isDenomEnabled,
  setIsDenomEnabled,
  firstDenomInputRef,
  onContinueSubmit,
  setDenomError,
  showToggle = true,
}) {
  return (
    <div
      className={`flex flex-col h-full rounded-2xl overflow-hidden border-2 transition-all duration-300 ${!isCash
          ? "border-gray-200 bg-gray-50 opacity-50 pointer-events-none select-none"
          : !isDenomEnabled
            ? "border-gray-300 bg-gray-50"
            : hasError
              ? "border-red-400 bg-red-50 shadow-lg shadow-red-100"
              : "border-yellow-300 bg-yellow-50 shadow-lg shadow-yellow-100"
        }`}
    >
      {/* Panel header */}
      <div
        className={`px-4 py-3 border-b-2 shrink-0 ${!isCash
            ? "border-gray-200 bg-gray-100"
            : !isDenomEnabled
              ? "border-gray-300 bg-gray-100"
              : hasError
                ? "border-red-300 bg-red-100"
                : "border-yellow-300 bg-yellow-100"
          }`}
      >
        <div className="flex items-center justify-between gap-2">
          <div className="flex items-center gap-2">
            <span className="text-xl">🪙</span>
            <div>
              <p className="text-sm font-bold text-yellow-900">Denomination</p>
              <p className="text-xs text-yellow-700 font-medium">
                {!isCash
                  ? "Select Cash to enable"
                  : isDenomEnabled
                    ? "Optional breakdown"
                    : "Turned off"}
              </p>
            </div>
          </div>

          {/* ON/OFF Toggle */}
          {isCash && showToggle && (
            <div className="flex items-center gap-2 shrink-0">
              <button
                type="button"
                onClick={() => setIsDenomEnabled((p) => !p)}
                aria-pressed={isDenomEnabled}
                className={`w-12 h-6 flex items-center rounded-full p-0.5 duration-300 focus:outline-none focus:ring-2 focus:ring-yellow-400 focus:ring-offset-1 ${isDenomEnabled ? "bg-yellow-500" : "bg-gray-400"
                  }`}
              >
                <div
                  className={`bg-white w-5 h-5 rounded-full shadow-md transform duration-300 ${isDenomEnabled ? "translate-x-6" : "translate-x-0"
                    }`}
                />
              </button>
              <span
                className={`text-xs font-bold w-6 ${isDenomEnabled ? "text-yellow-700" : "text-gray-500"
                  }`}
              >
                {isDenomEnabled ? "ON" : "OFF"}
              </span>
            </div>
          )}
        </div>

        {hasError && isCash && isDenomEnabled && (
          <DenominationErrorBanner
            hasError={hasError}
            message="Denomination total is less than the MOI amount. Please re-enter the denomination count."
          />
        )}
      </div>

      {/* Disabled overlay message when toggled OFF */}
      {isCash && !isDenomEnabled ? (
        <div className="flex-1 flex flex-col items-center justify-center text-gray-400 gap-2 py-8 px-4 text-center">
          <span className="text-3xl">🪙</span>
          <p className="text-sm font-semibold text-gray-500">
            Denomination tracking is off
          </p>
          <p className="text-xs text-gray-400">
            Toggle ON above to record note-wise breakdown
          </p>
        </div>
      ) : (
        <>
          {/* Scrollable denom rows */}
          <div className="denom-list grid flex-1 grid-cols-1 gap-2 overflow-y-auto px-3 py-3 sm:grid-cols-2">
            {DENOMS.map((denom) => {
              const count = parseInt(denomCounts[denom]) || 0;
              const subtotal = count * denom;
              return (
                <div
                  key={denom}
                  className={`rounded-xl border-2 p-2.5 transition-all ${count > 0
                      ? "border-emerald-300 bg-white shadow-sm"
                      : "border-gray-200 bg-white"
                    }`}
                >
                  <div className="flex items-center gap-2">
                    {/* Denom label */}
                    <div
                      className={`shrink-0 w-14 text-center rounded-lg py-1.5 border-2 font-bold text-sm ${count > 0
                          ? "border-emerald-400 bg-emerald-50 text-emerald-700"
                          : "border-gray-300 bg-gray-50 text-gray-600"
                        }`}
                    >
                      ₹{denom}
                    </div>

                    {/* Minus */}
                    <button
                      type="button"
                      onClick={() =>
                        setDenomCounts((p) => ({
                          ...p,
                          [denom]: Math.max(0, (parseInt(p[denom]) || 0) - 1),
                        }))
                      }
                      onMouseDown={() => {
                        if (hasError) setDenomError(false);
                      }}
                      className="w-7 h-7 shrink-0 rounded-lg bg-gray-200 hover:bg-red-100 text-gray-700 hover:text-red-600 font-bold text-base flex items-center justify-center transition-all active:scale-90"
                    >
                      −
                    </button>

                    {/* Count input */}
                    <input
                      ref={denom === DENOMS[0] ? firstDenomInputRef : undefined}
                      type="number"
                      min="0"
                      value={denomCounts[denom]}
                      placeholder="0"
                      onChange={(e) =>
                        setDenomCounts((p) => ({
                          ...p,
                          [denom]: e.target.value,
                        }))
                      }
                      onInput={() => {
                        if (hasError) setDenomError(false);
                      }}
                      onKeyDown={(e) => {
                        if (e.key !== "Enter") return;
                        e.preventDefault();
                        e.stopPropagation();
                        const idx = DENOMS.indexOf(denom);
                        if (idx < DENOMS.length - 1) {
                          const inputs = e.currentTarget
                            .closest(".denom-list")
                            ?.querySelectorAll("input[type='number']");
                          if (inputs?.[idx + 1]) inputs[idx + 1].focus();
                        } else {
                          onContinueSubmit?.();
                        }
                      }}
                      className="flex-1 min-w-0 text-center px-1 py-1.5 border-2 border-gray-300 rounded-lg text-sm font-bold font-mono caret-black focus:outline-none focus:ring-[4px] focus:ring-indigo-600/40 focus:border-indigo-600 focus:bg-indigo-50 placeholder-gray-300 text-gray-800 bg-gray-50"
                    />

                    {/* Plus */}
                    <button
                      type="button"
                      onClick={() =>
                        setDenomCounts((p) => ({
                          ...p,
                          [denom]: (parseInt(p[denom]) || 0) + 1,
                        }))
                      }
                      onMouseDown={() => {
                        if (hasError) setDenomError(false);
                      }}
                      className="w-7 h-7 shrink-0 rounded-lg bg-gray-200 hover:bg-emerald-100 text-gray-700 hover:text-emerald-700 font-bold text-base flex items-center justify-center transition-all active:scale-90"
                    >
                      +
                    </button>
                  </div>

                  {/* Subtotal row */}
                  {count > 0 && (
                    <div className="mt-1.5 flex items-center justify-between px-1">
                      <span className="text-xs text-gray-400">
                        {count} × ₹{denom}
                      </span>
                      <span className="text-xs font-bold text-emerald-600 font-mono">
                        = {formatCurrency(subtotal)}
                      </span>
                    </div>
                  )}
                </div>
              );
            })}
          </div>

          {/* Total + Apply — sticky footer */}
          <div
            className={`shrink-0 px-3 py-3 border-t-2 ${hasError
                ? "border-red-300 bg-red-100"
                : "border-yellow-300 bg-yellow-100"
              }`}
          >
            <div className="flex items-center justify-between mb-2">
              <span className="text-xs font-bold text-gray-600 uppercase tracking-wide">
                Counted Total
              </span>
              <span
                className={`text-xl font-bold font-mono ${denomTotal > 0 ? "text-emerald-700" : "text-gray-400"
                  }`}
              >
                {formatCurrency(denomTotal)}
              </span>
            </div>

          </div>
        </>
      )}
    </div>
  );
}

// ─── Keyboard-aware Field ─────────────────────────────────────────────────────
function DenominationModal({
  open,
  denomCounts,
  setDenomCounts,
  denomTotal,
  hasError,
  isDenomEnabled,
  setIsDenomEnabled,
  firstDenomInputRef,
  onSkip,
  onContinue,
  onClose,
  setDenomError,
}) {
  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[110] flex items-center justify-center bg-black/60 backdrop-blur-sm p-4"
      onKeyDown={(e) => {
        if (e.key !== "Escape") return;
        e.preventDefault();
        e.stopPropagation();
        onSkip?.();
      }}
    >
      <div className="w-full max-w-3xl overflow-hidden rounded-2xl bg-white shadow-2xl">
        <div className="flex items-center justify-between border-b border-gray-100 px-5 py-4">
          <div>
            <h3 className="text-lg font-black text-gray-900">
              Cash Denomination
            </h3>
            <p className="mt-1 text-xs font-semibold text-gray-500">
              Add note-wise count, or skip and submit without denomination.
            </p>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="flex items-center gap-1.5 px-3 py-2 text-sm font-bold text-gray-700 bg-gray-100 rounded-xl transition hover:bg-gray-200 hover:text-gray-900 border border-gray-200 shadow-sm"
            aria-label="Go back to entry form"
          >
            <FaChevronLeft size={14} />
            <span>Back</span>
          </button>
        </div>

        <div className="max-h-[70vh] overflow-y-auto p-4">
          <DenominationPanel
            denomCounts={denomCounts}
            setDenomCounts={setDenomCounts}
            denomTotal={denomTotal}
            isCash
            hasError={hasError}
            isDenomEnabled={isDenomEnabled}
            setIsDenomEnabled={setIsDenomEnabled}
            firstDenomInputRef={firstDenomInputRef}
            showToggle={false}
            onContinueSubmit={onContinue}
            setDenomError={setDenomError}
          />
        </div>

        <div className="flex flex-col gap-3 border-t border-gray-100 bg-gray-50 px-5 py-4 sm:flex-row sm:justify-end">
          <button
            type="button"
            onClick={onSkip}
            className="rounded-xl border border-gray-300 bg-white px-5 py-3 text-sm font-bold text-gray-700 transition hover:bg-gray-100"
          >
            Skip Denomination
            <span className="ml-2 rounded-md bg-gray-100 px-2 py-0.5 text-xs font-black text-gray-500">
              Esc
            </span>
          </button>
          <button
            type="button"
            onClick={onContinue}
            className="rounded-xl bg-gray-900 px-5 py-3 text-sm font-bold text-white shadow transition hover:bg-gray-800"
          >
            Continue Submit
          </button>
        </div>
      </div>
    </div>
  );
}

function KbField({
  innerRef,
  nextRef,
  onEnterSubmit = false,
  submitFormRef,
  submitRef,
  firstDenomRef,
  isDenomEnabled,
  isCash,
  ...props
}) {
  const handleKeyDown = (e) => {
    if (e.key !== "Enter") return;
    e.preventDefault();
    e.stopPropagation();
    if (onEnterSubmit) {
      if (isDenomEnabled && isCash && firstDenomRef?.current) {
        firstDenomRef.current.focus();
        flashEl(firstDenomRef.current, [
          "ring-4",
          "ring-yellow-400",
          "ring-offset-1",
        ]);
      } else {
        flashEl(submitRef?.current, [
          "ring-4",
          "ring-yellow-400",
          "ring-offset-2",
        ]);
        submitFormRef?.current?.();
      }
    } else if (nextRef?.current) {
      nextRef.current.focus();
    }
  };
  return <Field {...props} innerRef={innerRef} onKeyDown={handleKeyDown} />;
}

// ─── Labeled Field Box ────────────────────────────────────────────────────────
function FieldBox({ label, required, hint, error, action, children }) {
  return (
    <div className="flex flex-col gap-1.5">
      <div className="flex items-center justify-between gap-1.5 flex-wrap">
        <div className="flex items-baseline gap-1.5 flex-wrap">
          <label className="text-sm font-bold text-gray-700">
            {label} {required && <span className="text-red-500">*</span>}
          </label>
          {hint && (
            <span className="text-[10px] text-gray-400 font-normal">{hint}</span>
          )}
        </div>
        {action}
      </div>
      {children}
      {error && <p className="text-xs font-semibold text-red-500">{error}</p>}
    </div>
  );
}

// ─── Main Component ───────────────────────────────────────────────────────────
function isUnusedToken(token) {
  return (
    token?.active === 1 ||
    token?.active === "1" ||
    token?.active === true ||
    String(token?.token_status || "").toLowerCase() === "pending"
  );
}

function TokenStatusBadge({ token }) {
  const isPending = isUnusedToken(token);

  return (
    <span
      className={`inline-flex rounded-full px-2.5 py-1 text-[11px] font-black uppercase tracking-wide ${isPending
          ? "bg-amber-100 text-amber-800 border border-amber-200"
          : "bg-emerald-100 text-emerald-800 border border-emerald-200"
        }`}
    >
      {isPending ? "Pending" : "Used"}
    </span>
  );
}

function TokenTable({ tokens, onApply, emptyText, showApply }) {
  if (tokens.length === 0) {
    return (
      <div className="rounded-2xl border border-dashed border-gray-200 bg-gray-50 px-4 py-8 text-center text-sm font-bold text-gray-500">
        {emptyText}
      </div>
    );
  }

  return (
    <div className="overflow-hidden rounded-2xl border border-gray-200">
      <table className="min-w-full divide-y divide-gray-200 text-left text-sm">
        <thead className="sticky top-0 bg-gray-100 text-xs uppercase tracking-wide text-gray-600">
          <tr>
            <th className="px-3 py-3 font-black">Token</th>
            <th className="px-3 py-3 font-black">Name</th>
            <th className="px-3 py-3 font-black">Mobile</th>
            <th className="px-3 py-3 font-black">Type</th>
            <th className="px-3 py-3 font-black">Amount / Gift</th>
            <th className="px-3 py-3 font-black">Location</th>
            <th className="px-3 py-3 font-black">Status</th>
            {showApply && <th className="px-3 py-3 font-black">Action</th>}
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-100 bg-white">
          {tokens.map((token, index) => {
            const location = [token.village, token.area, token.city, token.state]
              .filter(Boolean)
              .join(", ");
            const assetType = token.asset_type || "-";
            const amountOrGift =
              assetType === "cash" || assetType === "online"
                ? formatCurrency(token.amount)
                : token.asset || "-";

            return (
              <tr
                key={token.token_id || token.token || index}
                className={index % 2 === 0 ? "bg-white" : "bg-gray-50"}
              >
                <td className="px-3 py-3 font-black text-gray-900">
                  #{token.token || "-"}
                </td>
                <td className="px-3 py-3">
                  <div className="font-bold text-gray-900">
                    {token.name || "-"}
                  </div>
                  {token.family_name && (
                    <div className="text-xs font-semibold text-gray-500">
                      {token.family_name}
                    </div>
                  )}
                </td>
                <td className="px-3 py-3 font-bold text-gray-900">
                  {token.mobile || "-"}
                </td>
                <td className="px-3 py-3 font-semibold capitalize text-gray-700">
                  {assetType}
                </td>
                <td className="px-3 py-3 font-bold text-gray-900">
                  {amountOrGift}
                </td>
                <td className="px-3 py-3 text-xs font-semibold text-gray-600">
                  {location || "-"}
                </td>
                <td className="px-3 py-3">
                  <TokenStatusBadge token={token} />
                </td>
                {showApply && (
                  <td className="px-3 py-3">
                    <button
                      type="button"
                      onClick={() => onApply?.(token)}
                      className="rounded-xl bg-amber-400 px-3 py-2 text-xs font-black text-gray-950 transition hover:bg-amber-300"
                    >
                      Apply
                    </button>
                  </td>
                )}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

function EventTokensModal({ open, tokens, loading, onClose, onRefresh, onApply }) {
  const [mobileFilter, setMobileFilter] = useState("");

  if (!open) return null;

  const normalizedFilter = (mobileFilter || "").trim();
  const filteredTokens = normalizedFilter
    ? tokens.filter((t) => (String(t.mobile || "") || "").includes(normalizedFilter))
    : tokens;

  const unusedTokens = filteredTokens.filter(isUnusedToken);
  const usedTokens = filteredTokens.filter((token) => !isUnusedToken(token));
  const pendingCount = unusedTokens.length;
  const usedCount = usedTokens.length;

  return (
    <div className="fixed inset-0 z-[110] flex items-center justify-center bg-black/60 p-4 backdrop-blur-sm">
      <div className="flex max-h-[86vh] w-full max-w-5xl flex-col overflow-hidden rounded-2xl bg-white shadow-2xl">
        <div className="flex flex-col gap-3 border-b border-gray-200 bg-gray-900 px-5 py-4 text-white sm:flex-row sm:items-center sm:justify-between">
          <div>
            <h3 className="text-lg font-black tracking-wide">Event Tokens</h3>
            <p className="text-xs font-semibold text-gray-300">
              Tokens created against this event with mobile number and status
            </p>
          </div>

          <div className="flex flex-wrap items-center gap-2">
            <div className="flex items-center gap-2">
              <input
                type="search"
                value={mobileFilter}
                onChange={(e) => setMobileFilter(e.target.value)}
                placeholder="Search mobile"
                className="rounded-xl border border-white/20 bg-white/5 px-3 py-2 text-xs text-white placeholder-white/60 caret-white focus:outline-none"
              />
              {mobileFilter && (
                <button
                  type="button"
                  onClick={() => setMobileFilter("")}
                  className="rounded-xl bg-white/10 px-2 py-1 text-xs font-semibold text-white"
                >
                  Clear
                </button>
              )}
            </div>
            <span className="rounded-full bg-white/10 px-3 py-1 text-xs font-bold">
              Total: {filteredTokens.length}
            </span>
            <span className="rounded-full bg-amber-400/20 px-3 py-1 text-xs font-bold text-amber-100">
              Pending: {pendingCount}
            </span>
            <span className="rounded-full bg-emerald-400/20 px-3 py-1 text-xs font-bold text-emerald-100">
              Used: {usedCount}
            </span>
            <button
              type="button"
              onClick={onRefresh}
              disabled={loading}
              className="rounded-xl bg-white px-3 py-2 text-xs font-black text-gray-900 transition hover:bg-gray-100 disabled:opacity-60"
            >
              {loading ? "Loading..." : "Refresh"}
            </button>
            <button
              type="button"
              onClick={onClose}
              className="rounded-xl border border-white/20 px-3 py-2 text-xs font-black text-white transition hover:bg-white/10"
            >
              Close
            </button>
          </div>
        </div>

        <div className="min-h-0 flex-1 overflow-auto p-4">
          {loading ? (
            <div className="flex min-h-52 items-center justify-center text-sm font-bold text-gray-500">
              Loading token list...
            </div>
          ) : tokens.length === 0 ? (
            <div className="flex min-h-52 flex-col items-center justify-center rounded-2xl border-2 border-dashed border-gray-200 bg-gray-50 text-center">
              <p className="text-base font-black text-gray-700">
                No tokens created for this event
              </p>
              <p className="mt-1 text-xs font-semibold text-gray-400">
                Customer-created tokens will appear here once available.
              </p>
            </div>
          ) : (
            <div className="space-y-5">
              <section>
                <div className="mb-2 flex items-center justify-between">
                  <h4 className="text-sm font-black text-gray-900">
                    Unused Tokens
                  </h4>
                  <span className="rounded-full bg-amber-100 px-3 py-1 text-xs font-black text-amber-800">
                    {unusedTokens.length}
                  </span>
                </div>
                <TokenTable
                  tokens={unusedTokens}
                  onApply={onApply}
                  emptyText="No unused tokens for this event"
                  showApply
                />
              </section>

              <section>
                <div className="mb-2 flex items-center justify-between">
                  <h4 className="text-sm font-black text-gray-900">
                    Used Tokens
                  </h4>
                  <span className="rounded-full bg-emerald-100 px-3 py-1 text-xs font-black text-emerald-800">
                    {usedTokens.length}
                  </span>
                </div>
                <TokenTable
                  tokens={usedTokens}
                  emptyText="No used tokens for this event"
                  showApply={false}
                />
              </section>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

const TrainingPage = () => {
  const logo = require("../assets/images/logo.jpeg");
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [showLiveEntries, setShowLiveEntries] = useState(true);
  const isTranslatorEnabled = useSelector(
    (state) => state.userStatus.translatorState,
  );
  const [token, setToken] = useState("");
  const [filledData, setFilledData] = useState({});
  const [isOnPrint, setIsOnPrint] = useState(() => {
    const saved = localStorage.getItem("is-on-print");
    return saved !== null ? JSON.parse(saved) : true;
  });
  const [isDenomEnabled, setIsDenomEnabled] = useState(() => {
    const saved = localStorage.getItem("is-denom-enabled");
    return saved !== null ? JSON.parse(saved) : true;
  });

  const [isFullScreen, setIsFullScreen] = useState(false);
  const isPrintingRef = useRef(false);
  const wasFullscreenBeforePrintRef = useRef(false);
  const shouldRestoreFullscreenOnInteractionRef = useRef(false);
  const tokenRef = useRef();

  const focusTokenInput = useCallback(() => {
    const doFocus = () => {
      const el = tokenRef.current;
      if (el && typeof el.focus === "function") {
        el.focus({ preventScroll: true });
        if (typeof el.select === "function") {
          el.select();
        }
      }
    };

    doFocus();
    if (typeof requestAnimationFrame === "function") {
      requestAnimationFrame(() => {
        doFocus();
        requestAnimationFrame(doFocus);
      });
    }

    const delays = [50, 100, 200, 350, 500, 800, 1100, 1300];
    delays.forEach((delay) => {
      setTimeout(doFocus, delay);
    });
  }, []);

  const handleBeforePrint = useCallback(async () => {
    isPrintingRef.current = true;
    wasFullscreenBeforePrintRef.current =
      isFullScreen || !!document.fullscreenElement;
  }, [isFullScreen]);

  const handleAfterPrint = useCallback(() => {
    setTimeout(() => {
      isPrintingRef.current = false;
    }, 600);

    if (wasFullscreenBeforePrintRef.current) {
      setIsFullScreen(true);
      if (!document.fullscreenElement && document.documentElement.requestFullscreen) {
        document.documentElement
          .requestFullscreen()
          .then(() => {
            focusTokenInput();
          })
          .catch(() => {
            shouldRestoreFullscreenOnInteractionRef.current = true;
            focusTokenInput();
          });
      }
    }

    focusTokenInput();
  }, [focusTokenInput]);

  const toggleFullScreen = () => {
    if (!isFullScreen) {
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen().catch(() => {});
      }
      setShowLiveEntries(true);
      setIsFullScreen(true);
      wasFullscreenBeforePrintRef.current = false;
      shouldRestoreFullscreenOnInteractionRef.current = false;
    } else {
      if (document.fullscreenElement && document.exitFullscreen) {
        document.exitFullscreen().catch(() => {});
      }
      setIsFullScreen(false);
      wasFullscreenBeforePrintRef.current = false;
      shouldRestoreFullscreenOnInteractionRef.current = false;
    }
  };
  const [moiList, setMoiList] = useState([]);
  const [listLoading, setListLoading] = useState(true);
  const [flashMessage, setFlashMessage] = useState("");
  const [denomError, setDenomError] = useState(false);
  const [showDenominationModal, setShowDenominationModal] = useState(false);
  const [isSubmittingEntry, setIsSubmittingEntry] = useState(false);
  const [showMismatchAlert, setShowMismatchAlert] = useState(false);
  const [mismatchData, setMismatchData] = useState({
    denomTotal: 0,
    amountValue: 0,
    returnAmount: 0,
  });
  const [showHelp, setShowHelp] = useState(false);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [paymentModalTimer, setPaymentModalTimer] = useState(20);
  const [paymentQrCode, setPaymentQrCode] = useState("");
  const [paymentQrError, setPaymentQrError] = useState("");
  const [isHeaderCollapsed, setIsHeaderCollapsed] = useState(true);
  const [thaaiMamanUpdatingIds, setThaaiMamanUpdatingIds] = useState([]);
  const [showThaaiMamanModal, setShowThaaiMamanModal] = useState(false);
  const [editingEntryId, setEditingEntryId] = useState(null);
  const [showTokenModal, setShowTokenModal] = useState(false);
  const [eventTokens, setEventTokens] = useState([]);
  const [tokensLoading, setTokensLoading] = useState(false);

  // ─── Offline Support ──────────────────────────────────────────────────────
  const { isOnline, wasOffline } = useNetworkStatus();
  const [pendingCount, setPendingCount] = useState(0);
  const [failedCount, setFailedCount] = useState(0);
  const [failedEntries, setFailedEntries] = useState([]);
  const [isSyncing, setIsSyncing] = useState(false);
  const [syncError, setSyncError] = useState("");
  const syncIntervalRef = useRef(null);

  useEffect(() => {
    const handleFullscreenChange = () => {
      const isNowFullscreen = !!document.fullscreenElement;
      if (isPrintingRef.current) {
        // Native print dialog temporarily exited browser fullscreen - DO NOT exit app fullscreen
        return;
      }
      setIsFullScreen(isNowFullscreen);
      if (isNowFullscreen) {
        setShowLiveEntries(true);
      }
    };
    document.addEventListener("fullscreenchange", handleFullscreenChange);
    document.addEventListener("webkitfullscreenchange", handleFullscreenChange);
    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
      document.removeEventListener("webkitfullscreenchange", handleFullscreenChange);
    };
  }, []);

  useEffect(() => {
    const onBefore = () => handleBeforePrint();
    const onAfter = () => handleAfterPrint();
    const onWindowFocus = () => {
      if (isPrintingRef.current) {
        focusTokenInput();
      }
    };
    window.addEventListener("beforeprint", onBefore);
    window.addEventListener("afterprint", onAfter);
    window.addEventListener("focus", onWindowFocus);
    return () => {
      window.removeEventListener("beforeprint", onBefore);
      window.removeEventListener("afterprint", onAfter);
      window.removeEventListener("focus", onWindowFocus);
    };
  }, [handleBeforePrint, handleAfterPrint, focusTokenInput]);

  useEffect(() => {
    const handlePreloaderHidden = () => {
      focusTokenInput();
    };
    window.addEventListener("preloader:hidden", handlePreloaderHidden);
    return () => {
      window.removeEventListener("preloader:hidden", handlePreloaderHidden);
    };
  }, [focusTokenInput]);

  useEffect(() => {
    const handleUserInteraction = () => {
      if (shouldRestoreFullscreenOnInteractionRef.current) {
        shouldRestoreFullscreenOnInteractionRef.current = false;
        if (
          wasFullscreenBeforePrintRef.current &&
          !document.fullscreenElement &&
          document.documentElement.requestFullscreen
        ) {
          document.documentElement
            .requestFullscreen()
            .then(() => {
              focusTokenInput();
            })
            .catch(() => {});
        }
      }
    };

    window.addEventListener("keydown", handleUserInteraction, true);
    window.addEventListener("pointerdown", handleUserInteraction, true);
    return () => {
      window.removeEventListener("keydown", handleUserInteraction, true);
      window.removeEventListener("pointerdown", handleUserInteraction, true);
    };
  }, [focusTokenInput]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape" && isFullScreen) {
        if (showDenominationModal) return;
        if (document.fullscreenElement && document.exitFullscreen) {
          document.exitFullscreen().catch(() => {});
        }
        setIsFullScreen(false);
        wasFullscreenBeforePrintRef.current = false;
        shouldRestoreFullscreenOnInteractionRef.current = false;
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [isFullScreen, showDenominationModal]);

  const eventInfo = staticEventInfo;
  const acceptOnline = eventInfo?.accept_online_payments ?? true;
  const paymentDetails = parseOnlinePaymentDetails(
    eventInfo?.online_payment_details,
  );
  const accountDetails = paymentDetails?.account_details;
  const upiId = paymentDetails?.upi_id;
  const rawPaymentDetails = paymentDetails?.raw_details;
  const upiPaymentUri = buildUpiPaymentUri({
    upiId,
    note: eventInfo?.customer_name || eventInfo?.event_type || "Event MOI",
  });
  const showPaymentDetails = Boolean(
    accountDetails || upiId || rawPaymentDetails,
  );

  const createEmptyDenomCounts = useCallback(
    () => Object.fromEntries(DENOMS.map((d) => [d, ""])),
    [],
  );
  const [denomCounts, setDenomCounts] = useState(createEmptyDenomCounts);
  const denomTotal = DENOMS.reduce(
    (s, d) => s + (parseInt(denomCounts[d]) || 0) * d,
    0,
  );

  const exportStats = useMemo(() => buildExportStats(moiList), [moiList]);

  useEffect(() => {
    localStorage.setItem("is-on-print", JSON.stringify(isOnPrint));
  }, [isOnPrint]);

  useEffect(() => {
    localStorage.setItem("is-denom-enabled", JSON.stringify(isDenomEnabled));
  }, [isDenomEnabled]);

  // ─── Offline: load pending count on mount & after syncs ──────────────────
  const refreshPendingCount = useCallback(async () => {
    try {
      const count = await db.pendingEntries
        .where("sync_status")
        .equals("pending")
        .count();
      setPendingCount(count);

      const failed = await db.pendingEntries
        .where("sync_status")
        .equals("failed")
        .toArray();
      setFailedCount(failed.length);
      setFailedEntries(failed);
    } catch (e) {
      // IndexedDB may not be available
    }
  }, []);

  const handleDiscardFailedEntry = async (id) => {
    try {
      await db.pendingEntries.delete(id);
      await refreshPendingCount();
      SuccessToast("Rejected offline entry discarded.");
    } catch (e) {
      console.error(e);
    }
  };

  const handleRetryFailedEntry = async (id) => {
    try {
      await db.pendingEntries.update(id, { sync_status: "pending" });
      await refreshPendingCount();
      syncPendingEntries();
    } catch (e) {
      console.error(e);
    }
  };

  const handleDiscardAllFailedEntries = async () => {
    try {
      const failed = await db.pendingEntries.where("sync_status").equals("failed").toArray();
      for (const entry of failed) {
        await db.pendingEntries.delete(entry.id);
      }
      await refreshPendingCount();
      SuccessToast("All rejected offline entries discarded.");
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    refreshPendingCount();
  }, [refreshPendingCount]);


  // ─── Refs ──────────────────────────────────────────────────────────────────
  const villageRef = useRef();
  const areaRef = useRef();
  const cityRef = useRef();
  const stateRef = useRef();
  const initialRef = useRef();
  const nameRef = useRef();
  const occupationRef = useRef();
  const familyRef = useRef();
  const mobileRef = useRef();
  const assetTypeRef = useRef();
  const amountRef = useRef();
  const thingnameRef = useRef();
  const submitRef = useRef();
  const firstDenomInputRef = useRef();
  const submitLockRef = useRef(false);
  const submitFormRef = useRef(null);
  const applyTokenToFormRef = useRef(null);
  const setValuesRef = useRef(null);
  const mismatchConfirmedRef = useRef(false);
  const denominationPromptHandledRef = useRef(false);
  const denominationSubmitModeRef = useRef(null);

  useEffect(() => {
    focusTokenInput();
  }, [focusTokenInput]);

  const fetchMoiList = useCallback(async (showOverlay = false) => {
    if (showOverlay) {
      dispatch(setShowPreloader(true));
    }
    const startTime = Date.now();
    const res = await AxiosGetMethod("entry/list");
    if (showOverlay) {
      const elapsed = Date.now() - startTime;
      if (elapsed < 1000) {
        await new Promise((resolve) => setTimeout(resolve, 1000 - elapsed));
      }
      dispatch(setShowPreloader(false));
    }
    if (res?.status === 200) setMoiList(res.data?.data || []);
    else if (res?.status === 401) HandleLogout();
    setListLoading(false);
  }, [dispatch]);

  // ─── Offline: sync pending entries to server ──────────────────────────────
  const syncPendingEntries = useCallback(async () => {
    if (isSyncing) return;
    setSyncError("");
    let pending;
    try {
      pending = await db.pendingEntries
        .where("sync_status")
        .equals("pending")
        .toArray();
    } catch (e) {
      return;
    }
    if (!pending || pending.length === 0) return;

    setIsSyncing(true);
    let syncedCount = 0;
    try {
      for (const entry of pending) {
        try {
          // eslint-disable-next-line no-unused-vars
          const { id, uuid, sync_status, created_at, event_id, operator_id, error_message, ...body } = entry;
          const res = await AxiosPostMethod("entry/new", body);
          if (res?.status === 200) {
            await db.pendingEntries.update(id, { sync_status: "synced" });
            syncedCount++;
            if (res.data?.data?.low_wallet_balance) {
              ErrorToast("Organization Wallet Balance is low! Whatsapp confirmation not sent.");
            }
          } else if (res?.status === 401) {
            HandleLogout();
            break;
          } else if (res?.status >= 400 && res?.status < 500) {
            // Client error or invalid entry rejected by server
            await db.pendingEntries.update(id, {
              sync_status: "failed",
              error_message: res.data?.message || "Invalid entry rejected by server",
            });
            setSyncError(res.data?.message || "An offline entry was rejected by the server.");
          } else {
            setSyncError("Offline entries are saved locally, but the server did not accept the sync yet. We will keep retrying automatically.");
            break;
          }
        } catch (err) {
          setSyncError("Offline entries are saved locally, but the server could not be reached right now.");
          break;
        }
      }
      if (syncedCount > 0) {
        SuccessToast(`${syncedCount} offline ${syncedCount === 1 ? "entry" : "entries"} synced successfully!`);
        setSyncError("");
        fetchMoiList();
      }
      await refreshPendingCount();
    } finally {
      setIsSyncing(false);
    }
  }, [isSyncing, refreshPendingCount, fetchMoiList]);

  // ─── Offline: auto-sync when network comes back ───────────────────────────
  useEffect(() => {
    if (isOnline && wasOffline) {
      syncPendingEntries();
    }
  }, [isOnline, wasOffline, syncPendingEntries]);

  // ─── Offline: periodic sync attempt every 30s ─────────────────────────────
  useEffect(() => {
    syncIntervalRef.current = setInterval(() => {
      syncPendingEntries();
      refreshPendingCount();
    }, 30000);
    return () => clearInterval(syncIntervalRef.current);
  }, [syncPendingEntries, refreshPendingCount]);

  const fetchEventTokens = useCallback(async () => {
    setTokensLoading(true);
    const startTime = Date.now();
    const res = await AxiosGetMethod("entry/tokens");
    const elapsed = Date.now() - startTime;
    if (elapsed < 1000) {
      await new Promise((resolve) => setTimeout(resolve, 1000 - elapsed));
    }
    if (res?.status === 200) {
      setEventTokens(res.data?.data || []);
    } else if (res?.status === 401) {
      HandleLogout();
    } else {
      ErrorToast(res?.data?.message || "Unable to fetch event tokens");
    }
    setTokensLoading(false);
  }, []);

  const openTokenModal = useCallback(() => {
    setShowTokenModal(true);
    fetchEventTokens();
  }, [fetchEventTokens]);

  const applyTokenToEntryForm = (tokenInfo, setValues) => {
    if (!tokenInfo?.token) {
      ErrorToast("Unable to apply this token");
      return;
    }

    setToken(String(tokenInfo.token));
    const { name: parsedName, initial: parsedInitial } = parseNameAndInitial(tokenInfo.name);
    setValues({
      amount: tokenInfo.amount || "",
      assetType: tokenInfo.asset_type || "cash",
      thingname: tokenInfo.asset || "",
      datetime: getCurrentDateTime(),
      name: parsedName,
      initial: parsedInitial,
      occupation: tokenInfo.occupation || "",
      village: tokenInfo.village || "",
      area: tokenInfo.area || "",
      city: tokenInfo.city || "",
      state: tokenInfo.state || "தமிழ்நாடு",
      mobile: tokenInfo.mobile || "",
      familyName: tokenInfo.family_name || "",
    });
    setShowTokenModal(false);
    SuccessToast(`Token ${tokenInfo.token} applied`);
    setTimeout(() => villageRef.current?.focus(), 100);
  };

  useEffect(() => {
    fetchMoiList(true);
  }, [fetchMoiList]);

  // Pre-load entry for editing when navigated from Moi List page
  useEffect(() => {
    const entryToEdit = location.state?.editEntry;
    if (!entryToEdit) return;
    // Wait until Formik's setValues is available via setValuesRef
    const intervalId = setInterval(() => {
      if (setValuesRef.current) {
        clearInterval(intervalId);
        startEditingEntry(entryToEdit, setValuesRef.current);
        // Clear the navigation state so it doesn't re-trigger on re-render
        window.history.replaceState({}, "");
      }
    }, 100);
    return () => clearInterval(intervalId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Payment modal timer and auto-close
  useEffect(() => {
    if (showPaymentModal && paymentModalTimer > 0) {
      const timer = setInterval(() => {
        setPaymentModalTimer((prev) => {
          if (prev <= 1) {
            setShowPaymentModal(false);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);

      return () => clearInterval(timer);
    }
  }, [showPaymentModal, paymentModalTimer]);

  useEffect(() => {
    if (!upiPaymentUri) {
      setPaymentQrCode("");
      setPaymentQrError("");
      return;
    }

    let isActive = true;
    setPaymentQrCode("");
    setPaymentQrError("");

    QRCode.toDataURL(upiPaymentUri, {
      width: 280,
      margin: 2,
      color: {
        dark: "#0f172a",
        light: "#ffffff",
      },
    })
      .then((dataUrl) => {
        if (!isActive) return;
        setPaymentQrCode(dataUrl);
      })
      .catch(() => {
        if (!isActive) return;
        setPaymentQrError("Unable to generate the UPI QR right now.");
      });

    return () => {
      isActive = false;
    };
  }, [upiPaymentUri]);

  const showFlash = (name) => {
    setFlashMessage(`Entry added for ${name}`);
    setTimeout(() => setFlashMessage(""), 3000);
  };

  const handleThaaiMamanToggle = useCallback(async (entry, checked) => {
    const entryId = entry?.entry_id;
    if (!entryId) {
      ErrorToast("Unable to update Thaai Maman for this entry");
      return;
    }

    const nextValue = checked ? 1 : 0;
    const previousValue = entry?.thaai_maman;

    setThaaiMamanUpdatingIds((prev) => [...prev, entryId]);
    setMoiList((prev) =>
      prev.map((item) =>
        item.entry_id === entryId ? { ...item, thaai_maman: nextValue } : item,
      ),
    );

    try {
      const res = await AxiosPutMethod("entry/thaai-maman", {
        entry_id: entryId,
        thaai_maman: nextValue,
      });

      if (res?.status === 200) {
        SuccessToast(
          `Thaai Maman ${checked ? "enabled" : "disabled"} for ${entry.name || "entry"}`,
        );
        if (checked) {
          setShowThaaiMamanModal(true);
        }
        return;
      }

      setMoiList((prev) =>
        prev.map((item) =>
          item.entry_id === entryId
            ? { ...item, thaai_maman: previousValue }
            : item,
        ),
      );

      if (res?.status === 401) HandleLogout();
      ErrorToast(res?.data?.message || "Unable to update Thaai Maman");
    } catch (error) {
      setMoiList((prev) =>
        prev.map((item) =>
          item.entry_id === entryId
            ? { ...item, thaai_maman: previousValue }
            : item,
        ),
      );
      ErrorToast("Unable to update Thaai Maman");
    } finally {
      setThaaiMamanUpdatingIds((prev) => prev.filter((id) => id !== entryId));
    }
  }, []);

  const getCurrentDateTime = useCallback(() => {
    const now = new Date();
    return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}T${String(now.getHours()).padStart(2, "0")}:${String(now.getMinutes()).padStart(2, "0")}`;
  }, []);

  const clearEditState = useCallback(() => {
    setEditingEntryId(null);
    setToken("");
    setDenomCounts(createEmptyDenomCounts());
    setDenomError(false);
    setShowDenominationModal(false);
    denominationPromptHandledRef.current = false;
    denominationSubmitModeRef.current = null;
  }, [createEmptyDenomCounts]);

  const startEditingEntry = useCallback(
    (entry, setValues) => {
      if (!entry?.entry_id) {
        ErrorToast("Unable to edit this entry");
        return;
      }

      const denominationCounts = Object.fromEntries(
        DENOMS.map((d) => [
          d,
          entry?.denomination_breakdown?.[String(d)] !== undefined
            ? String(entry.denomination_breakdown[String(d)])
            : "",
        ]),
      );
      const hasDenominationValues = Object.values(denominationCounts).some(
        (value) => parseInt(value, 10) > 0,
      );

      setEditingEntryId(entry.entry_id);
      setToken(entry.token || "");
      setDenomCounts(denominationCounts);
      setDenomError(false);
      setIsDenomEnabled(entry.asset_type === "cash" && hasDenominationValues);
      const { name: parsedName, initial: parsedInitial } = parseNameAndInitial(entry.name);
      setValues({
        amount: entry.amount || "",
        assetType: entry.asset_type || "cash",
        thingname: entry.asset || "",
        datetime: getCurrentDateTime(),
        name: parsedName,
        initial: parsedInitial,
        occupation: entry.occupation || "",
        village: entry.village || "",
        area: entry.area || "",
        city: entry.city || "",
        state: entry.state || "தமிழ்நாடு",
        mobile: entry.mobile || "",
        familyName: entry.family_name || "",
      });
      SuccessToast("Entry loaded for editing");
      setTimeout(() => mobileRef.current?.focus(), 100);
    },
    [getCurrentDateTime],
  );

  const handleExportPdf = () => {
    if (moiList.length === 0) {
      ErrorToast("No entries available to export");
      return;
    }

    const printWindow = window.open("", "_blank", "width=1200,height=900");
    if (!printWindow) {
      ErrorToast("Popup blocked. Please allow popups to export PDF");
      return;
    }

    const html = buildPdfDocumentHtmlTamil({
      eventInfo,
      entries: moiList,
      stats: exportStats,
    });

    printWindow.document.open();
    printWindow.document.write(html);
    printWindow.document.close();

    setTimeout(() => {
      printWindow.focus();
      printWindow.print();
    }, 300);

    SuccessToast("தமிழ் PDF ஏற்றுமதி திறக்கப்பட்டது");
  };

  const handleExportExcel = () => {
    if (moiList.length === 0) {
      ErrorToast("No entries available to export");
      return;
    }

    const html = buildExcelWorksheetHtmlTamil({
      eventInfo,
      entries: moiList,
      stats: exportStats,
    });

    const fileName = `மொய்-பதிவுகள்-${new Date().toISOString().slice(0, 10)}.xls`;
    downloadFile(
      `\ufeff${html}`,
      fileName,
      "application/vnd.ms-excel;charset=utf-8;",
    );
    SuccessToast("தமிழ் Excel ஏற்றுமதி பதிவிறக்கம் செய்யப்பட்டது");
  };

  const HandleFillByToken = async (event, setValues, options = {}) => {
    const value = event.target.value.trim();
    setToken(value);
    if (!value) {
      mobileRef.current?.focus();
      return;
    }
    const getRes = await AxiosGetMethod(
      `entry/get-token-details?token=${value}`,
    );
    if (getRes.status === 200) {
      if (getRes.data?.data?.length > 0) {
        const info = getRes.data.data[0];
        const { name: parsedName, initial: parsedInitial } = parseNameAndInitial(info.name);
        setValues({
          amount: info.amount,
          assetType: info.asset_type,
          thingname: info.asset || "",
          datetime: getCurrentDateTime(),
          name: parsedName,
          initial: parsedInitial,
          occupation: info.occupation || "",
          village: info.village || "",
          area: info.area || "",
          city: info.city || "",
          state: info.state,
          mobile: info.mobile,
          familyName: info.family_name,
        });
        SuccessToast("Token information found");
        if (!options.skipDefaultFocus) {
          setTimeout(() => villageRef.current?.focus(), 100);
        }
      } else {
        ErrorToast("Invalid Token. Enter details manually");
        if (!options.skipDefaultFocus) {
          setTimeout(() => villageRef.current?.focus(), 100);
        }
      }
    } else {
      if (getRes?.status === 401) HandleLogout();
      if (getRes.status === 400) ErrorToast(getRes.data.message);
      else ErrorToast("Error fetching token data");
    }
  };

  const lastFilledMobileRef = useRef("");
  const mobileDebounceRef = useRef(null);

  const HandleFillByMobile = useCallback((mobile, setValues) => {
    if (mobileDebounceRef.current) {
      clearTimeout(mobileDebounceRef.current);
    }

    if (mobile.length !== 10) {
      lastFilledMobileRef.current = "";
      return;
    }

    if (mobile === lastFilledMobileRef.current) return;

    mobileDebounceRef.current = setTimeout(async () => {
      try {
        const res = await AxiosGetMethod(
          `entry/get-info-by-mobile?mobile=${mobile}`,
        );
        if (res?.status === 200 && res.data?.data) {
          lastFilledMobileRef.current = mobile;
          const info = res.data.data;
          const { name: parsedName, initial: parsedInitial } = parseNameAndInitial(info.first_name);
          setValues((prev) => ({
            ...prev,
            name: parsedName || prev.name,
            initial: parsedInitial !== "" ? parsedInitial : prev.initial,
            occupation: info.occupation || prev.occupation,
            familyName: info.last_name || prev.familyName,
            village: info.village || prev.village,
            area: info.area || prev.area,
            city: info.city || prev.city,
            state: info.state || prev.state,
          }));
          SuccessToast("Info filled from mobile number");
          setTimeout(() => assetTypeRef.current?.focus(), 100);
        }
      } catch (error) {
        console.error("Failed to fetch mobile info:", error);
      }
    }, 400);
  }, []);

  const ensureCustomerRegistered = async (values) => {
    const mobile = String(values.mobile || "").trim();

    if (!/^[0-9]{10}$/.test(mobile)) return;

    const existingCustomerRes = await AxiosGetMethod(
      `entry/get-info-by-mobile?mobile=${mobile}`,
    );

    if (existingCustomerRes?.status === 200) return;

    const registrationRes = await AxiosPostMethod(
      "customer/registration",
      getCustomerRegistrationPayload({ ...values, mobile }),
      true,
    );

    if (
      registrationRes?.status &&
      registrationRes.status !== 200 &&
      registrationRes.status !== 409
    ) {
      ErrorToast("Entry saved, but customer auto-registration failed.");
    }
  };

  const validationSchema = Yup.object({
    assetType: Yup.string().required("Asset type is required"),
    amount: Yup.number()
      .nullable()
      .when("assetType", {
        is: (v) => v === "cash" || v === "online",
        then: (s) =>
          s.required("Amount is required").positive("Amount must be positive"),
        otherwise: (s) => s.notRequired(),
      }),
    thingname: Yup.string()
      .nullable()
      .when("assetType", {
        is: (v) => v === "things" || v === "ornaments",
        then: (s) => s.required("Please enter the item received"),
        otherwise: (s) => s.notRequired(),
      }),
    datetime: Yup.date().required("Date and time are required"),
    name: Yup.string().required("Name is required"),
    initial: Yup.string(),
    area: Yup.string(),
    village: Yup.string().test(
      "village-or-city",
      "Enter at least village or city",
      function (value) {
        const { city, area } = this.parent;
        return !!(value?.trim() || city?.trim() || area?.trim());
      },
    ),
    city: Yup.string().test(
      "village-or-city",
      "Enter at least village or city",
      function (value) {
        const { village, area } = this.parent;
        return !!(value?.trim() || village?.trim() || area?.trim());
      },
    ),
    state: Yup.string().required("State is required"),
    mobile: Yup.string()
      .test(
        "is-valid-mobile",
        "Must be 10 digits",
        (val) => !val || /^[0-9]{10}$/.test(val)
      ),
    occupation: Yup.string(),
    familyName: Yup.string(),
  });

  const initialValues = {
    amount: "",
    assetType: "cash",
    thingname: "",
    datetime: getCurrentDateTime(),
    name: "",
    initial: "",
    occupation: "",
    village: "",
    area: "",
    city: "",
    state: "தமிழ்நாடு",
    mobile: "",
    familyName: "",
  };

  const handleSubmit = async (
    values,
    { resetForm, setFieldError, setSubmitting },
  ) => {
    // Modal confirmations resume this submission immediately. A time-based
    // cooldown here would consume them; only an active save blocks re-entry.
    if (submitLockRef.current) return;

    if (
      values.assetType === "cash" &&
      isDenomEnabled &&
      !denominationPromptHandledRef.current
    ) {
      setDenomError(false);
      setShowDenominationModal(true);
      setSubmitting(false);
      setTimeout(() => firstDenomInputRef.current?.focus(), 100);
      return;
    }

    const shouldUseDenomination =
      values.assetType === "cash" &&
      denominationSubmitModeRef.current !== "skip" &&
      isDenomEnabled;

    if (shouldUseDenomination) {
      const hasDenomEntries = Object.values(denomCounts).some(
        (v) => v !== "" && parseInt(v) > 0,
      );
      const amountValue = parseFloat(values.amount) || 0;

      if (amountValue > denomTotal) {
        mismatchConfirmedRef.current = false;
        setDenomError(true);
        setFieldError(
          "amount",
          "Denomination total is less than the MOI amount",
        );
        ErrorToast(
          "Denomination total is less than the MOI amount. Please re-enter denomination.",
        );
        setShowDenominationModal(true);
        setSubmitting(false);
        setTimeout(() => firstDenomInputRef.current?.focus(), 100);
        return;
      }

      setDenomError(false);

      if (
        hasDenomEntries &&
        amountValue < denomTotal &&
        !mismatchConfirmedRef.current
      ) {
        const returnAmount = denomTotal - amountValue;
        setMismatchData({ denomTotal, amountValue, returnAmount });
        setShowMismatchAlert(true);
        setSubmitting(false);
        return;
      }
    }
    mismatchConfirmedRef.current = false;
    setDenomError(false);

    submitLockRef.current = true;
    setIsSubmittingEntry(true);
    setSubmitting(true);
    dispatch(setShowPreloader(true));
    const startTime = Date.now();

    const denominationBreakdown =
      shouldUseDenomination
        ? Object.fromEntries(
          DENOMS.filter((d) => parseInt(denomCounts[d]) > 0).map((d) => [
            String(d),
            parseInt(denomCounts[d]),
          ]),
        )
        : null;

    const clientUuid = uuidv4();
    const combinedName = getCombinedName(values.name, values.initial);

    const body = {
      client_uuid: clientUuid,
      asset_type: values.assetType,
      amount: values.amount,
      asset: values.thingname,
      name: combinedName,
      occupation: values.occupation,
      family_name: values.familyName,
      mobile: values.mobile,
      village: values.village,
      area: values.area,
      city: values.city,
      state: values.state,
      token: token || "",
      denomination_breakdown: denominationBreakdown,
      receipt_no: moiList.length + pendingCount + 1,
    };

    try {
      setFilledData(body);

      // ─── Offline-first: save to IndexedDB then try server ─────────
      if (editingEntryId) {
        // Edits must go online; cannot edit offline
        const res = await AxiosPutMethod("entry/update", {
          entry_id: editingEntryId,
          ...body,
        });
        const elapsed = Date.now() - startTime;
        if (elapsed < 1000) {
          await new Promise((resolve) => setTimeout(resolve, 1000 - elapsed));
        }
        if (res.status === 200) {
          resetForm();
          clearEditState();
          fetchMoiList();
          SuccessToast("Entry updated successfully");
          denominationPromptHandledRef.current = false;
          denominationSubmitModeRef.current = null;
          focusTokenInput();
        } else {
          if (res?.status === 401) HandleLogout();
          ErrorToast("Something went wrong, please contact admin");
        }
      } else {
        // ── New entry: save locally first, then try API ──
        const localEntry = {
          uuid: clientUuid,
          event_id: eventInfo?.event_id || "",
          operator_id: eventInfo?.operator_id || "",
          sync_status: "pending",
          created_at: new Date().toISOString(),
          ...body,
        };
        const localId = await db.pendingEntries.add(localEntry);
        await refreshPendingCount();

        // Save village/city to local cache for instant autocomplete suggestions
        try {
          const cached = JSON.parse(localStorage.getItem("cached_villages") || "[]");
          let updatedCache = false;
          [body.village, body.area, body.city].forEach((item) => {
            if (item && typeof item === "string" && item.trim().length > 1 && !cached.includes(item.trim())) {
              cached.unshift(item.trim());
              updatedCache = true;
            }
          });
          if (updatedCache) {
            localStorage.setItem("cached_villages", JSON.stringify(cached.slice(0, 500)));
          }
        } catch (e) {}

        // Try server immediately
        let synced = false;
        try {
          const res = await AxiosPostMethod("entry/new", body);
          const elapsed = Date.now() - startTime;
          if (elapsed < 1000) {
            await new Promise((resolve) => setTimeout(resolve, 1000 - elapsed));
          }
          if (res?.status === 200) {
            await db.pendingEntries.update(localId, { sync_status: "synced" });
            await refreshPendingCount();
            synced = true;
            await ensureCustomerRegistered({ ...values, name: combinedName });
            fetchMoiList();

            if (res.data?.data?.latest_wallet_balance !== undefined) {
              const updatedEventInfo = { ...eventInfo, organisation_wallet_balance: res.data.data.latest_wallet_balance };
              localStorage.setItem("event-info", JSON.stringify(updatedEventInfo));
            }
            if (res.data?.data?.low_wallet_balance) {
              ErrorToast("Organization Wallet Balance is low! Whatsapp confirmation not sent.");
            }
          } else if (res?.status === 401) {
            HandleLogout();
          } else if (res?.status >= 400 && res?.status < 500) {
            await db.pendingEntries.update(localId, {
              sync_status: "failed",
              error_message: res.data?.message || "Validation rejected by server",
            });
            await refreshPendingCount();
            ErrorToast(res.data?.message || "Entry rejected by server");
          }
        } catch (networkErr) {
          // Server unreachable — entry is safely stored locally
        }

        if (isOnPrint) {
          // react-to-print clones the receipt immediately. Commit the saved
          // entry before cloning so rapid/offline saves print the current data.
          flushSync(() => setFilledData(body));
          reactToPrintFn();
        }
        resetForm();
        clearEditState();

        if (synced) {
          showFlash(combinedName);
        } else {
          SuccessToast(
            `Entry for "${combinedName}" saved offline. Will sync when network returns.`
          );
        }

        denominationPromptHandledRef.current = false;
        denominationSubmitModeRef.current = null;
        focusTokenInput();
      }
    } catch (err) {
      const elapsed = Date.now() - startTime;
      if (elapsed < 1000) {
        await new Promise((resolve) => setTimeout(resolve, 1000 - elapsed));
      }
      ErrorToast("Something went wrong, please contact admin");
    } finally {
      denominationPromptHandledRef.current = false;
      denominationSubmitModeRef.current = null;
      submitLockRef.current = false;
      setIsSubmittingEntry(false);
      setSubmitting(false);
      dispatch(setShowPreloader(false));
      focusTokenInput();
    }
  };

  const componentRef = useRef();
  const reactToPrintFn = useReactToPrint({
    contentRef: componentRef,
    documentTitle: "MoiReceipt",
    onBeforePrint: handleBeforePrint,
    onAfterPrint: handleAfterPrint,
    onPrintError: () => {
      handleAfterPrint();
      ErrorToast("Entry saved, but receipt printing failed. Please check the printer and try again.");
    },
  });

  const ToggleRow = ({
    label,
    value,
    onChange,
    onColor = "bg-emerald-500",
  }) => (
    <div className="flex items-center gap-3">
      <span className="text-sm text-gray-400 hidden sm:block">{label}</span>
      <button
        type="button"
        onClick={onChange}
        aria-pressed={value}
        className={`w-14 h-7 flex items-center rounded-full p-1 duration-300 focus:outline-none focus:ring-2 focus:ring-yellow-400 focus:ring-offset-4 focus:ring-offset-gray-900 ${value ? onColor : "bg-gray-600"
          }`}
      >
        <div
          className={`bg-white w-5 h-5 rounded-full shadow-md transform duration-300 ${value ? "translate-x-7" : ""
            }`}
        />
      </button>
      <span
        className={`text-xs font-semibold w-7 ${value ? "text-emerald-400" : "text-gray-500"
          }`}
      >
        {value ? "ON" : "OFF"}
      </span>
    </div>
  );

  return (
    // ── Root: lock to viewport, no outer scroll ──────────────────────────────
    <div
      className={`h-screen overflow-hidden ${
        isFullScreen ? "p-2 bg-gray-100" : "pt-5 px-3 sm:px-4 bg-gray-100"
      } flex flex-col`}
    >
      <div
        className={`${
          isFullScreen ? "w-full" : "max-w-screen-2xl mx-auto w-full"
        } flex flex-col flex-1 min-h-0`}
      >
        {/* ── Minimal Full Screen Header ──────────────────────────────────── */}
        {isFullScreen && (
          <div className="shrink-0 mb-2 flex items-center justify-between rounded-xl bg-gray-900 px-3.5 py-2 text-white shadow-lg border border-gray-800">
            <div className="flex items-center gap-2.5">
              <span className="flex h-2.5 w-2.5 rounded-full bg-emerald-400 animate-pulse" />
              <h1 className="text-xs sm:text-sm font-black tracking-wider uppercase">
                MOI NOTE <span className="text-gray-400 font-semibold text-xs hidden sm:inline">· Full Screen Mode</span>
              </h1>
              {eventInfo?.customer_name && (
                <span className="hidden md:inline-flex items-center text-xs text-gray-300 font-medium bg-gray-800 px-2.5 py-0.5 rounded-md border border-gray-700">
                  {eventInfo.customer_name} {eventInfo.event_type ? `(${eventInfo.event_type})` : ""}
                </span>
              )}
            </div>

            <div className="flex items-center gap-2">
              <ToggleRow
                label="Tamil"
                value={isTranslatorEnabled}
                onChange={() => dispatch(setTranslatorState(!isTranslatorEnabled))}
                onColor="bg-sky-500"
              />
              <div className="w-px h-4 bg-gray-700 mx-1 hidden sm:block" />
              <ToggleRow
                label="Print"
                value={isOnPrint}
                onChange={() => setIsOnPrint((p) => !p)}
                onColor="bg-emerald-500"
              />
              <div className="w-px h-4 bg-gray-700 mx-1 hidden sm:block" />
              <button
                type="button"
                onClick={toggleFullScreen}
                className="inline-flex items-center gap-1.5 rounded-lg bg-indigo-600 hover:bg-indigo-500 text-white px-3 py-1.5 text-xs font-bold transition shadow-sm active:scale-95"
                title="Exit Full Screen (Esc)"
              >
                <FaCompress size={12} />
                <span>Exit Full Screen</span>
              </button>
            </div>
          </div>
        )}

        {!isFullScreen && (
          <>
            {/* ── Offline / Sync Status Banner ────────────────────────────────── */}
        {!isOnline && (
          <div className="shrink-0 mb-2 flex items-center gap-3 rounded-xl border-2 border-red-500 bg-red-500/10 px-4 py-3 text-red-700 shadow-lg animate-pulse">
            <MdSignalWifiOff size={22} className="shrink-0" />
            <div className="flex-1">
              <p className="text-sm font-bold">
                ⚠️ No Internet Connection — Offline Mode Active
              </p>
              <p className="text-xs mt-0.5 text-red-600">
                Entries are saved locally on this laptop. Do NOT shut down or close this browser until the internet is restored and all entries are synced.
              </p>
            </div>
          </div>
        )}
        {pendingCount > 0 && (
          <div
            className={`shrink-0 mb-2 flex items-center gap-3 rounded-xl border-2 px-4 py-2.5 shadow ${
              isSyncing
                ? "border-amber-400 bg-amber-50 text-amber-800"
                : "border-yellow-400 bg-yellow-50 text-yellow-800"
            }`}
          >
            <FaSync
              size={16}
              className={`shrink-0 ${isSyncing ? "animate-spin" : ""}`}
            />
            <div className="flex-1">
              <p className="text-sm font-bold">
                {isSyncing
                  ? `Syncing ${pendingCount} offline ${pendingCount === 1 ? "entry" : "entries"} to server...`
                  : `${pendingCount} offline ${pendingCount === 1 ? "entry" : "entries"} waiting to sync`}
              </p>
            </div>
          </div>
        )}
        {failedCount > 0 && (
          <div className="shrink-0 mb-2 flex items-center justify-between gap-3 rounded-xl border-2 border-rose-400 bg-rose-50 px-4 py-2.5 text-rose-800 shadow">
            <div className="flex items-center gap-2">
              <MdWarning size={18} className="shrink-0 text-rose-600" />
              <div>
                <p className="text-sm font-bold">
                  {failedCount} offline {failedCount === 1 ? "entry was" : "entries were"} rejected by server
                </p>
                {failedEntries[0]?.error_message && (
                  <p className="text-xs text-rose-600 mt-0.5">
                    Reason: {failedEntries[0].error_message}
                  </p>
                )}
              </div>
            </div>
            <div className="flex items-center gap-2 shrink-0">
              <button
                type="button"
                onClick={() => handleRetryFailedEntry(failedEntries[0]?.id)}
                className="rounded-lg bg-rose-600 px-3 py-1 text-xs font-semibold text-white hover:bg-rose-700 transition"
              >
                Retry
              </button>
              <button
                type="button"
                onClick={handleDiscardAllFailedEntries}
                className="rounded-lg bg-white border border-rose-300 px-3 py-1 text-xs font-semibold text-rose-700 hover:bg-rose-100 transition"
              >
                Discard
              </button>
            </div>
          </div>
        )}
        {syncError && failedCount === 0 && (
          <div className="shrink-0 mb-2 flex items-center gap-3 rounded-xl border-2 border-orange-400 bg-orange-50 px-4 py-2.5 text-orange-800 shadow">
            <MdWarning size={16} className="shrink-0" />
            <p className="text-sm font-bold">{syncError}</p>
          </div>
        )}
        {isOnline && wasOffline && pendingCount === 0 && (
          <div className="shrink-0 mb-2 flex items-center gap-3 rounded-xl border-2 border-emerald-400 bg-emerald-50 px-4 py-2.5 text-emerald-700 shadow">
            <FaWifi size={16} className="shrink-0" />
            <p className="text-sm font-bold">
              ✅ Back Online — All entries are synced!
            </p>
          </div>
        )}

        {/* ── Low Wallet Balance Warning ────────────────────────────────── */}
        {eventInfo?.organisation_wallet_balance < 1000 && eventInfo?.moi_confirmation_sms == 1 && (
          <div className="shrink-0 mb-2 flex items-center gap-3 rounded-xl border-2 border-orange-500 bg-orange-50 px-4 py-3 text-orange-700 shadow-lg animate-pulse">
            <MdWarning size={22} className="shrink-0" />
            <div className="flex-1">
              <p className="text-sm font-bold">
                ⚠️ Low Wallet Balance
              </p>
              <p className="text-xs mt-0.5 text-orange-600">
                Your balance is running out. Please recharge. If the balance runs out, WhatsApp messages will not be sent.
              </p>
            </div>
          </div>
        )}

        {/* ── Training Mode Alert ───────────────────────────────────────── */}
        <div className="shrink-0 mb-4 flex items-start gap-3 rounded-xl border-2 border-amber-400 bg-amber-50 px-4 py-3 text-amber-800 shadow-lg">
          <MdWarning size={22} className="shrink-0 text-amber-600 mt-0.5" />
          <div className="flex-1">
            <p className="text-sm font-extrabold uppercase tracking-widest text-amber-900">
              Training Mode
            </p>
            <p className="text-xs mt-1 font-medium text-amber-700 leading-relaxed">
              This is a static training session. Data is saved in your browser's local storage and not synced to the server. 
              To test the <strong>Permanent Token</strong> flow (existing customer), use the sample mobile number: <strong>9999999999</strong>. 
              Any other number will trigger the temporary token flow.
            </p>
          </div>
        </div>

        {/* ── Page header ─────────────────────────────────────────────────── */}
        <div className="shrink-0 mb-4 rounded-2xl bg-gradient-to-r from-gray-900 to-gray-800 px-4 py-3 shadow-xl sm:px-6">
          <div className="flex min-w-0 items-center justify-between gap-4">
            <div className="w-11 h-11 rounded-xl bg-white/10 border border-white/20 flex items-center justify-center overflow-hidden">
              <img src={logo} alt="" className="w-9 h-9 object-contain" />
            </div>
            <div className="flex min-w-0 flex-1 items-center justify-between gap-3">
              <div className="min-w-0 flex flex-1 items-center gap-3">
                <h1 className="whitespace-nowrap text-base font-bold tracking-[0.2em] text-white sm:text-lg">
                  MOI NOTE
                </h1>
                <p className="hidden sm:block text-xs text-gray-400">
                  Event Contribution Register
                </p>
                {!isHeaderCollapsed && (
                  <div className="hidden xl:flex items-center rounded-xl border border-red-400/30 bg-red-500/10 px-3 py-2 text-xs font-semibold text-red-100">
                    <span className="font-bold uppercase tracking-[0.16em] text-red-200">
                      Disclaimer
                    </span>
                    <span className="ml-2 text-red-50/90">
                      This data is confidential. If you leak this data, it will lead to severe action.
                    </span>
                  </div>
                )}
              </div>

              <div className="flex shrink-0 items-center gap-2">
                <button
                  type="button"
                  onClick={() => setShowThaaiMamanModal(true)}
                  className="hidden md:inline-flex items-center gap-2 rounded-xl border border-emerald-400/30 bg-emerald-500/10 px-3 py-2 text-xs font-bold text-emerald-300 transition hover:bg-emerald-500/20"
                >
                  Thaai Maman Line Up
                </button>
                <div className="hidden sm:flex rounded-xl border border-white/15 bg-white/10 px-3 py-2">
                  <ToggleRow
                    label="Denomination"
                    value={isDenomEnabled}
                    onChange={() => {
                      setIsDenomEnabled((prev) => {
                        const next = !prev;
                        if (!next) {
                          setDenomError(false);
                          setDenomCounts(createEmptyDenomCounts());
                        }
                        return next;
                      });
                    }}
                    onColor="bg-yellow-500"
                  />
                </div>
                <button
                  type="button"
                  onClick={() => navigate("/home")}
                  className="inline-flex items-center gap-2 rounded-xl border border-white/15 bg-white/10 px-3 py-2 text-xs font-bold text-white transition hover:bg-white/15"
                >
                  <FaHome size={12} />
                  Home
                </button>
                <button
                  type="button"
                  onClick={openTokenModal}
                  className="inline-flex items-center gap-2 rounded-xl bg-amber-400 px-3 py-2 text-xs font-black text-gray-955 shadow transition hover:bg-amber-300"
                >
                  Show Tokens
                </button>
                <button
                  type="button"
                  onClick={() => navigate("/moilist")}
                  className="inline-flex items-center gap-2 rounded-xl bg-teal-500 px-3 py-2 text-xs font-black text-white shadow transition hover:bg-teal-400"
                >
                  Moi List View
                </button>
                <button
                  type="button"
                  onClick={toggleFullScreen}
                  className="inline-flex items-center gap-2 rounded-xl bg-indigo-600 px-3 py-2 text-xs font-black text-white shadow transition hover:bg-indigo-500 active:scale-95"
                  title="View Moi Entry form in full screen with live entries only"
                >
                  <FaExpand size={12} />
                  Full Screen
                </button>
                <button
                  type="button"
                  onClick={() => setIsHeaderCollapsed((prev) => !prev)}
                  className="inline-flex items-center gap-2 rounded-xl border border-white/15 bg-white/10 px-3 py-2 text-xs font-bold text-white transition hover:bg-white/15"
                  aria-expanded={!isHeaderCollapsed}
                >
                  {isHeaderCollapsed ? "Show Header" : "Hide Header"}
                  {isHeaderCollapsed ? (
                    <FaChevronDown size={12} />
                  ) : (
                    <FaChevronUp size={12} />
                  )}
                </button>
                <button
                  type="button"
                  onClick={() => HandleLogout()}
                  className="inline-flex items-center gap-2 rounded-xl border border-red-500/30 bg-red-500/10 px-3.5 py-2 text-xs font-bold text-red-300 transition hover:bg-red-500/20 active:scale-95"
                >
                  <IoLogOutOutline size={14} />
                  Logout
                </button>
              </div>
            </div>
          </div>

          {!isHeaderCollapsed && (
            <>
              <div className="mt-3 rounded-xl border border-red-400/30 bg-red-500/10 px-3 py-2 text-xs font-semibold text-red-100 xl:hidden">
                <span className="font-bold uppercase tracking-[0.16em] text-red-200">
                  Disclaimer
                </span>
                <span className="ml-2 text-red-50/90">
                  This data is confidential. If you leak this data, it will lead
                  to severe action.
                </span>
              </div>
              <div className="mt-3 flex w-full flex-wrap items-center gap-4 xl:w-auto xl:justify-end xl:gap-6">
                <div className="flex items-center gap-2">
                  <span className="text-sm font-bold text-gray-400 hidden sm:block">
                    Tamil Typing
                  </span>
                  <button
                    type="button"
                    onClick={() => setShowHelp(true)}
                    className="text-teal-500 hover:text-teal-400 transition-colors"
                    title="Keyboard Shortcuts Help"
                  >
                    <FaQuestionCircle size={16} />
                  </button>
                </div>
                <ToggleRow
                  label=""
                  value={isTranslatorEnabled}
                  onChange={() =>
                    dispatch(setTranslatorState(!isTranslatorEnabled))
                  }
                  onColor="bg-sky-500"
                />

                <div className="w-px h-6 bg-gray-700 hidden sm:block" />

                <ToggleRow
                  label="Print Receipt"
                  value={isOnPrint}
                  onChange={() => setIsOnPrint((p) => !p)}
                  onColor="bg-emerald-500"
                />

                <div className="w-px h-6 bg-gray-700 hidden sm:block" />

                <button
                  type="button"
                  onClick={() => {
                    setShowPaymentModal(true);
                    setPaymentModalTimer(20);
                  }}
                  className="inline-flex items-center gap-2 rounded-xl bg-blue-500 px-4 py-2 text-sm font-bold text-white shadow hover:bg-blue-700 transition"
                >
                  <span>💳</span>
                  Payment Details
                </button>

                <button
                  type="button"
                  onClick={handleExportPdf}
                  className="inline-flex items-center gap-2 rounded-xl bg-red-600 px-4 py-2 text-sm font-bold text-white shadow hover:bg-red-700 transition"
                >
                  <span>📄</span>
                  Export PDF
                </button>

                <button
                  type="button"
                  onClick={handleExportExcel}
                  className="inline-flex items-center gap-2 rounded-xl bg-emerald-600 px-4 py-2 text-sm font-bold text-white shadow hover:bg-emerald-700 transition"
                >
                  <span>📊</span>
                  Export Excel
                </button>
              </div>
            </>
          )}
        </div>
          </>
        )}

        {/* ── Export summary bar ───────────────────────────────────────────── */}
        {false ? (
          <>
            <div className="shrink-0 mb-4 rounded-2xl border border-gray-200 bg-white px-4 py-3 shadow-sm">
              <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
                <div>
                  <h2 className="text-sm font-bold uppercase tracking-wide text-gray-800">
                    Export Summary
                  </h2>
                  <p className="text-xs text-gray-500 mt-1">
                    Vendor details will appear on the first page. Total tally
                    info and confidentiality disclaimer are included in both PDF
                    and Excel exports.
                  </p>
                </div>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-2 min-w-0">
                  <div className="rounded-xl bg-gray-50 border border-gray-200 px-3 py-2">
                    <p className="text-[11px] uppercase text-gray-500 font-bold">
                      Entries
                    </p>
                    <p className="text-lg font-bold text-gray-900">
                      {exportStats.totalEntries}
                    </p>
                  </div>
                  <div className="rounded-xl bg-gray-50 border border-gray-200 px-3 py-2">
                    <p className="text-[11px] uppercase text-gray-500 font-bold">
                      Cash
                    </p>
                    <p className="text-lg font-bold text-emerald-700">
                      {formatCurrency(exportStats.totalCash)}
                    </p>
                  </div>
                  <div className="rounded-xl bg-gray-50 border border-gray-200 px-3 py-2">
                    <p className="text-[11px] uppercase text-gray-500 font-bold">
                      Online
                    </p>
                    <p className="text-lg font-bold text-blue-700">
                      {formatCurrency(exportStats.totalOnline)}
                    </p>
                  </div>
                  <div className="rounded-xl bg-gray-50 border border-gray-200 px-3 py-2">
                    <p className="text-[11px] uppercase text-gray-500 font-bold">
                      Gift Items
                    </p>
                    <p className="text-lg font-bold text-amber-700">
                      {exportStats.giftAssetCount}
                    </p>
                  </div>
                </div>
              </div>
              <div className="mt-3 rounded-xl border border-red-200 bg-red-50 px-3 py-2 text-xs font-semibold text-red-700">
                Disclaimer: This data is confidential. If you leak this data, it
                will lead to severe action.
              </div>
            </div>

            {/* ── 3-column layout ──────────────────────────────────────────────── */}
          </>
        ) : (
          <></>
        )}

        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({
            values,
            setValues,
            setFieldValue,
            setFieldTouched,
            errors,
            touched,
            isSubmitting,
            resetForm,
            submitForm,
          }) => {
            submitFormRef.current = submitForm;
            setValuesRef.current = setValues;
            applyTokenToFormRef.current = (tokenInfo) =>
              applyTokenToEntryForm(tokenInfo, setValues);
            const isSubmitDisabled = isSubmitting || isSubmittingEntry;

            return (
              <>
                <div className="flex flex-col lg:flex-row gap-4 items-stretch flex-1 min-h-0 pb-5">
                  {/* ── LEFT: Denomination Panel ─────────────────────────── */}
                  {/* ── CENTRE: Form ──────────────────────────────────────── */}
                  <div className="flex-1 min-w-0 min-h-0 overflow-y-auto">
                    <Form className="grid grid-cols-1 gap-3 md:grid-cols-2">
                      {editingEntryId && (
                        <div className="flex flex-col gap-3 rounded-2xl border border-sky-200 bg-sky-50 px-4 py-4 sm:flex-row sm:items-center sm:justify-between md:col-span-2">
                          <div>
                            <p className="text-sm font-bold text-sky-900">
                              Editing entry #{editingEntryId}
                            </p>
                            <p className="text-xs text-sky-700 mt-1">
                              Saving this form will permanently mark the entry as edited in exports.
                            </p>
                          </div>
                          <button
                            type="button"
                            onClick={() => {
                              resetForm();
                              clearEditState();
                              focusTokenInput();
                            }}
                            className="inline-flex items-center justify-center rounded-xl border border-sky-300 bg-white px-4 py-2 text-sm font-semibold text-sky-700 transition hover:bg-sky-100"
                          >
                            Cancel Edit
                          </button>
                        </div>
                      )}

                      <div className="grid grid-cols-1 gap-3 rounded-2xl border border-amber-200 bg-amber-50/70 p-3 shadow-sm md:col-span-2 md:grid-cols-2">
                        <div className="space-y-1.5">
                          <label className="block text-sm font-bold text-amber-800">
                            Temporary Token
                          </label>
                          <input
                            ref={tokenRef}
                            value={token}
                            className="w-full min-w-0 rounded-xl border-2 border-amber-400 bg-white px-4 py-3 font-mono text-sm font-bold uppercase tracking-[0.2em] text-amber-900 shadow-sm transition placeholder-amber-300 focus:outline-none caret-black focus:ring-2 focus:ring-indigo-500 sm:text-base sm:tracking-[0.3em]"
                            onChange={(e) => setToken(e.target.value)}
                            onKeyDown={async (e) => {
                              if (e.key !== "Enter") return;
                              e.preventDefault();
                              e.stopPropagation();
                              if (token.trim()) {
                                await HandleFillByToken(e, setValues, {
                                  skipDefaultFocus: true,
                                });
                              }
                              mobileRef.current?.focus();
                            }}
                            type="text"
                            name="token"
                            maxLength={6}
                          />
                        </div>

                        <FieldBox
                          label="Mobile / Permanent Token Number"
                          hint="Auto-fills when the mobile number already exists"
                          error={touched.mobile && errors.mobile}
                        >
                          <Field name="mobile">
                            {({ field }) => (
                              <input
                                {...field}
                                id="mobile"
                                ref={mobileRef}
                                type="text"
                                placeholder="10-digit number"
                                maxLength={10}
                                className="w-full rounded-xl border-2 border-amber-400 bg-white px-3 py-3 text-sm font-semibold text-gray-800 shadow-sm transition placeholder-amber-400 focus:border-amber-500 caret-black focus:outline-none focus:ring-[4px] focus:ring-indigo-600/40 focus:border-indigo-600 focus:bg-indigo-50"
                                onChange={(e) => {
                                  field.onChange(e);
                                  HandleFillByMobile(e.target.value, setValues);
                                }}
                                onKeyDown={(e) => {
                                  if (e.key !== "Enter") return;
                                  e.preventDefault();
                                  e.stopPropagation();
                                  villageRef.current?.focus();
                                }}
                              />
                            )}
                          </Field>
                        </FieldBox>
                      </div>

                      {false && (
                        <div className="flex flex-col gap-3 bg-amber-100 border-2 border-amber-300 rounded-2xl px-4 py-3 sm:flex-row sm:items-center">
                          <span className="text-amber-600 text-xl shrink-0">
                            🎟️
                          </span>
                          <label className="text-sm font-bold text-amber-800 shrink-0 hidden sm:block">
                            Fill by Token
                          </label>
                          <input
                            value={token}
                            className="w-full min-w-0 flex-1 px-4 py-2 uppercase border-2 border-amber-400 bg-white text-sm sm:text-base font-mono font-bold rounded-xl caret-black focus:outline-none focus:ring-[4px] focus:ring-indigo-600/40 focus:border-indigo-600 focus:bg-indigo-50 placeholder-amber-300 tracking-[0.2em] sm:tracking-[0.3em] text-amber-900"
                            onChange={(e) => setToken(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key !== "Enter") return;
                              e.preventDefault();
                              e.stopPropagation();
                              HandleFillByToken(e, setValues);
                              villageRef.current?.focus();
                            }}
                            type="text"
                            name="token"
                            maxLength={6}
                          />
                        </div>
                      )}

                      <div className="flex flex-col gap-3">
                        <FieldBox
                          label="Village"
                          hint="(Village or City — at least one required)"
                          error={touched.village && errors.village}
                        >
                          <ConsolidatedVillageInput
                            id="village"
                            name="village"
                            placeholder="Village name"
                            innerRef={villageRef}
                            nextRef={areaRef}
                            moiList={moiList}
                            apiGet={AxiosGetMethod}
                            className="w-full px-3 py-3 border-2 border-gray-300 rounded-xl bg-gray-50 text-sm font-semibold text-gray-900 caret-black focus:outline-none focus:ring-[4px] focus:ring-indigo-600/40 focus:border-indigo-600 focus:bg-indigo-50 transition placeholder-gray-400 village-input"
                          />
                        </FieldBox>
                        <div className="grid grid-cols-12 gap-2">
                          <div className="col-span-6">
                            <FieldBox
                              label="Area"
                              error={touched.area && errors.area}
                            >
                              <VillageAreaInput
                                id="area"
                                name="area"
                                placeholder="Area / Locality"
                                innerRef={areaRef}
                                nextRef={cityRef}
                                moiList={moiList}
                                apiGet={AxiosGetMethod}
                                className="w-full px-3 py-3 border-2 border-gray-300 rounded-xl bg-gray-50 text-sm font-semibold text-gray-900 caret-black focus:outline-none focus:ring-[4px] focus:ring-indigo-600/40 focus:border-indigo-600 focus:bg-indigo-50 transition placeholder-gray-400"
                              />
                            </FieldBox>
                          </div>
                          <div className="col-span-6">
                            <FieldBox
                              label="City"
                              hint="(Village or City — at least one required)"
                              error={touched.city && errors.city}
                            >
                              <CitySearchSelect
                                value={values.city}
                                onChange={(city) => setFieldValue("city", city)}
                                onBlur={() => setFieldTouched("city", true)}
                                onNext={() => initialRef.current?.focus()}
                                inputRef={cityRef}
                                className="w-full px-3 py-3 border-2 border-gray-300 rounded-xl bg-gray-50 text-sm font-semibold text-gray-900 caret-black focus:outline-none focus:ring-[4px] focus:ring-indigo-600/40 focus:border-indigo-600 focus:bg-indigo-50 transition placeholder-gray-400"
                                placeholder="City name"
                              />
                            </FieldBox>
                          </div>
                        </div>
                        <div className="grid grid-cols-12 gap-2">
                          <div className="col-span-4 sm:col-span-3">
                            <FieldBox
                              label="Initial"
                              error={touched.initial && errors.initial}
                            >
                              <KbField
                                id="initial"
                                name="initial"
                                type="text"
                                placeholder="Initial"
                                innerRef={initialRef}
                                nextRef={nameRef}
                                maxLength={6}
                                className="w-full px-3 py-3 border-2 border-gray-300 rounded-xl bg-gray-50 text-sm font-semibold text-gray-900 caret-black focus:outline-none focus:ring-[4px] focus:ring-indigo-600/40 focus:border-indigo-600 focus:bg-indigo-50 transition placeholder-gray-400 uppercase"
                              />
                            </FieldBox>
                          </div>
                          <div className="col-span-8 sm:col-span-9">
                            <FieldBox
                              label="Name"
                              required
                              error={touched.name && errors.name}
                            >
                              <VillageUserNameInput
                                id="name"
                                name="name"
                                placeholder="Full name"
                                innerRef={nameRef}
                                nextRef={occupationRef}
                                initialRef={initialRef}
                                occupationRef={occupationRef}
                                parseNameAndInitial={parseNameAndInitial}
                                moiList={moiList}
                                customAxiosGet={AxiosGetMethod}
                                className="w-full px-3 py-3 border-2 border-gray-300 rounded-xl bg-gray-50 text-sm font-semibold text-gray-900 caret-black focus:outline-none focus:ring-[4px] focus:ring-indigo-600/40 focus:border-indigo-600 focus:bg-indigo-50 transition placeholder-gray-400"
                              />
                            </FieldBox>
                          </div>
                        </div>
                        <FieldBox
                          label="Occupation"
                          error={touched.occupation && errors.occupation}
                        >
                          <KbField
                            id="occupation"
                            name="occupation"
                            type="text"
                            placeholder="Optional"
                            innerRef={occupationRef}
                            nextRef={values.assetType === "things" || values.assetType === "ornaments" ? thingnameRef : amountRef}
                            className="w-full px-3 py-3 border-2 border-gray-300 rounded-xl bg-gray-50 text-sm font-semibold text-gray-900 caret-black focus:outline-none focus:ring-[4px] focus:ring-indigo-600/40 focus:border-indigo-600 focus:bg-indigo-50 transition placeholder-gray-400"
                          />
                        </FieldBox>
                      </div>

                      <div className="flex flex-col gap-3">
                        <FieldBox
                          label="Father / Husband Name"
                          error={touched.familyName && errors.familyName}
                        >
                          <KbField
                            id="familyName"
                            name="familyName"
                            type="text"
                            placeholder="Optional"
                            innerRef={familyRef}
                            nextRef={stateRef}
                            className="w-full px-3 py-3 border-2 border-gray-300 rounded-xl bg-gray-50 text-sm font-semibold text-gray-900 caret-black focus:outline-none focus:ring-[4px] focus:ring-indigo-600/40 focus:border-indigo-600 focus:bg-indigo-50 transition placeholder-gray-400"
                          />
                        </FieldBox>
                        <FieldBox
                          label="State"
                          required
                          error={touched.state && errors.state}
                        >
                          <KbField
                            id="state"
                            name="state"
                            type="text"
                            placeholder="State"
                            innerRef={stateRef}
                            nextRef={assetTypeRef}
                            className="w-full px-3 py-3 border-2 border-gray-300 rounded-xl bg-gray-50 text-sm font-semibold text-gray-900 caret-black focus:outline-none focus:ring-[4px] focus:ring-indigo-600/40 focus:border-indigo-600 focus:bg-indigo-50 transition placeholder-gray-400"
                          />
                        </FieldBox>
                        <FieldBox
                          label="Asset Type"
                          required
                          error={touched.assetType && errors.assetType}
                        >
                          <Field
                            as="select"
                            name="assetType"
                            innerRef={assetTypeRef}
                            className="w-full px-3 py-3 border-2 border-gray-300 rounded-xl bg-gray-50 text-sm font-semibold text-gray-900 caret-black focus:outline-none focus:ring-[4px] focus:ring-indigo-600/40 focus:border-indigo-600 focus:bg-indigo-50 transition"
                            onChange={(e) => {
                              setFieldValue("assetType", e.target.value);
                              denominationPromptHandledRef.current = false;
                              denominationSubmitModeRef.current = null;
                              if (e.target.value !== "cash") {
                                setDenomError(false);
                              }
                            }}
                            onKeyDown={(e) => {
                              if (e.key !== "Enter") return;
                              e.preventDefault();
                              e.stopPropagation();
                              const isAsset =
                                values.assetType === "things" ||
                                values.assetType === "ornaments";
                              (isAsset
                                ? thingnameRef
                                : amountRef
                              ).current?.focus();
                            }}
                          >
                            <option value="">Select type</option>
                            <option value="cash">💵 Cash</option>
                            {acceptOnline && (
                              <option value="online">📲 Online Payment</option>
                            )}
                            <option value="ornaments">💍 Ornaments</option>
                            <option value="things">🎁 Things</option>
                          </Field>
                        </FieldBox>
                        {values.assetType === "things" ||
                          values.assetType === "ornaments" ? (
                          <FieldBox
                            label="Item Received"
                            required
                            error={touched.thingname && errors.thingname}
                          >
                            <KbField
                              id="thingname"
                              name="thingname"
                              type="text"
                              placeholder="e.g. Gold chain…"
                              innerRef={thingnameRef}
                              onEnterSubmit
                              submitFormRef={submitFormRef}
                              submitRef={submitRef}
                              firstDenomRef={firstDenomInputRef}
                              isDenomEnabled={false}
                              isCash={false}
                              className="w-full px-3 py-3 border-2 border-gray-300 rounded-xl bg-gray-50 text-sm font-semibold text-gray-900 caret-black focus:outline-none focus:ring-[4px] focus:ring-indigo-600/40 focus:border-indigo-600 focus:bg-indigo-50 transition placeholder-gray-400"
                            />
                          </FieldBox>
                        ) : (
                          <FieldBox
                            label="Amount (₹)"
                            required
                            error={touched.amount && errors.amount}
                          >
                            <Field name="amount">
                              {({ field, form }) => (
                                <>
                                  <input
                                    {...field}
                                    id="amount"
                                    ref={amountRef}
                                    type="text"
                                    placeholder="0"
                                    value={field.value ? Number(String(field.value).replace(/\D/g, "")).toLocaleString("en-IN") : ""}
                                    className="w-full px-3 py-3 border-2 border-gray-300 rounded-xl bg-gray-50 text-base font-bold text-gray-900 caret-black focus:outline-none focus:ring-[4px] focus:ring-indigo-600/40 focus:border-indigo-600 focus:bg-indigo-50 transition placeholder-gray-400 font-mono"
                                    onChange={(e) => {
                                      const rawValue = e.target.value.replace(/\D/g, "");
                                      form.setFieldValue("amount", rawValue);
                                      if (denomError) setDenomError(false);
                                    }}
                                    onKeyDown={(e) => {
                                      if (e.key !== "Enter") return;
                                      e.preventDefault();
                                      e.stopPropagation();
                                      flashEl(submitRef?.current, [
                                        "ring-4",
                                        "ring-yellow-400",
                                        "ring-offset-2",
                                      ]);
                                      submitFormRef.current?.();
                                    }}
                                  />
                                  {values.amount && (
                                    <div className="mt-1 text-xs font-semibold text-emerald-600 px-1">
                                      {numberToWords(values.amount)} ரூபாய் மட்டும்
                                    </div>
                                  )}
                                </>
                              )}
                            </Field>
                          </FieldBox>
                        )}
                      </div>
                      <button
                        ref={submitRef}
                        type="submit"
                        disabled={isSubmitDisabled}
                        className={`w-full py-4 text-white font-bold text-lg rounded-2xl transition duration-200 focus:outline-none focus:ring-2 focus:ring-yellow-400 focus:ring-offset-4 focus:ring-offset-gray-100 flex items-center justify-center gap-3 shadow-lg md:col-span-2 ${isSubmitDisabled
                            ? "bg-gray-500 cursor-not-allowed"
                            : "bg-gray-900 hover:bg-gray-800 active:bg-black group"
                          }`}
                      >
                        <span>
                          {isSubmitDisabled
                            ? "Submitting..."
                            : editingEntryId
                              ? "Update Entry"
                              : isOnPrint
                                ? "Submit & Print"
                                : "Submit Entry"}
                        </span>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className={`h-5 w-5 transition-transform ${isSubmitDisabled ? "" : "group-hover:translate-x-1"
                            }`}
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                          strokeWidth={2.5}
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M13 7l5 5m0 0l-5 5m5-5H6"
                          />
                        </svg>
                      </button>

                      <p className="text-center text-xs text-gray-400 pb-1 md:col-span-2">
                        Press{" "}
                        <kbd className="px-1.5 py-0.5 bg-white border-2 border-gray-200 rounded text-gray-600 font-mono text-xs font-bold">
                          Enter
                        </kbd>{" "}
                        on each field to advance · Last field submits
                      </p>
                    </Form>
                  </div>

                  {/* ── RIGHT: Live Entries ───────────────────────────────── */}
                  <div className={`shrink-0 min-h-0 transition-all duration-300 ${showLiveEntries ? (isFullScreen ? "w-full lg:w-80 xl:w-96" : "w-full lg:w-72 xl:w-80") : "w-12 flex flex-col"}`}>
                    {showLiveEntries ? (
                      <RunningList
                        entries={moiList}
                        loading={listLoading}
                        flashMessage={flashMessage}
                        editingEntryId={editingEntryId}
                        onEditEntry={(entry) => startEditingEntry(entry, setValues)}
                        onToggleThaaiMaman={handleThaaiMamanToggle}
                        thaaiMamanUpdatingIds={thaaiMamanUpdatingIds}
                        onClose={() => setShowLiveEntries(false)}
                      />
                    ) : (
                      <div
                        className="flex flex-col h-full bg-gray-950 text-white rounded-2xl overflow-hidden shadow-2xl border border-gray-800 items-center py-4 cursor-pointer hover:bg-gray-900 transition-colors"
                        onClick={() => setShowLiveEntries(true)}
                      >
                        <FaChevronLeft className="mb-4 text-gray-400" />
                        <span className="text-xs text-gray-400 font-bold uppercase tracking-widest" style={{ writingMode: 'vertical-rl', transform: 'rotate(180deg)' }}>
                          Live Entries
                        </span>
                      </div>
                    )}
                  </div>
                </div>
                <DenominationModal
                  open={showDenominationModal}
                  denomCounts={denomCounts}
                  setDenomCounts={setDenomCounts}
                  denomTotal={denomTotal}
                  hasError={denomError}
                  isDenomEnabled={isDenomEnabled}
                  setIsDenomEnabled={setIsDenomEnabled}
                  firstDenomInputRef={firstDenomInputRef}
                  setDenomError={setDenomError}
                  onSkip={() => {
                    denominationPromptHandledRef.current = true;
                    denominationSubmitModeRef.current = "skip";
                    mismatchConfirmedRef.current = false;
                    setDenomError(false);
                    setShowDenominationModal(false);
                    setTimeout(() => submitFormRef.current?.(), 0);
                  }}
                  onContinue={() => {
                    denominationPromptHandledRef.current = true;
                    denominationSubmitModeRef.current = "capture";
                    setShowDenominationModal(false);
                    setTimeout(() => submitFormRef.current?.(), 0);
                  }}
                  onClose={() => {
                    denominationPromptHandledRef.current = false;
                    denominationSubmitModeRef.current = null;
                    setShowDenominationModal(false);
                  }}
                />
              </>
            );
          }}
        </Formik>
      </div>

      <div style={{ display: "none" }}>
        <Receipt
          ref={componentRef}
          items={filledData}
          eventDetails={eventInfo}
        />
      </div>

      <EventTokensModal
        open={showTokenModal}
        tokens={eventTokens}
        loading={tokensLoading}
        onClose={() => setShowTokenModal(false)}
        onRefresh={fetchEventTokens}
        onApply={(tokenInfo) => applyTokenToFormRef.current?.(tokenInfo)}
      />

      {/* Help Modal */}
      {showHelp && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/60 backdrop-blur-sm p-4">
          <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full overflow-hidden animate-in fade-in zoom-in duration-200">
            <div className="p-6 border-b border-gray-100 flex items-center justify-between">
              <h3 className="text-xl font-black text-gray-800 tracking-tight">
                Tamil Typing Guide
              </h3>
              <button
                onClick={() => setShowHelp(false)}
                className="text-gray-400 hover:text-gray-600 transition-colors text-2xl"
              >
                ×
              </button>
            </div>
            <div className="p-6">
              <div className="bg-teal-50 border border-teal-100 rounded-xl p-4 mb-5 flex gap-4">
                <div className="w-12 h-12 rounded-full bg-teal-100 flex items-center justify-center shrink-0">
                  <FaKeyboard className="text-teal-600 text-xl" />
                </div>
                <div>
                  <p className="text-sm font-bold text-teal-900 mb-1">
                    How it works
                  </p>
                  <p className="text-xs text-teal-700 leading-relaxed">
                    Type any Tamil word in English (e.g., 'vanakkam') and press{" "}
                    <b>Space</b> or <b>Enter</b> to translate.
                  </p>
                </div>
              </div>

              <div className="space-y-4">
                <p className="text-xs font-black text-gray-400 uppercase tracking-widest">
                  Keyboard Shortcuts
                </p>
                <div className="grid grid-cols-1 gap-3">
                  {[
                    { key: "Alt + X", desc: "Cycle variants (ந → ண → ன)" },
                    { key: "Alt + 1", desc: "1st option (ந / ல / ர)" },
                    { key: "Alt + 2", desc: "2nd option (ண / ள / ற)" },
                    { key: "Alt + 3", desc: "3rd option (ன / ழ)" },
                  ].map((item, i) => (
                    <div
                      key={i}
                      className="flex items-center justify-between p-3 rounded-xl bg-slate-50 border border-slate-200 group hover:border-teal-300 hover:bg-teal-50 transition-all"
                    >
                      <span className="text-sm font-semibold text-gray-700">
                        {item.desc}
                      </span>
                      <kbd className="px-2.5 py-1 rounded-lg bg-white border border-gray-300 text-teal-700 text-xs font-black shadow-sm group-hover:border-teal-400 transition-colors">
                        {item.key}
                      </kbd>
                    </div>
                  ))}
                </div>
              </div>

              <div className="mt-8 flex justify-end">
                <button
                  onClick={() => setShowHelp(false)}
                  className="w-full sm:w-auto px-8 py-3 bg-teal-700 text-white rounded-xl text-sm font-bold shadow-lg shadow-teal-700/20 hover:bg-teal-800 transition-all active:scale-95"
                >
                  Got it
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <DenominationMismatchAlert
        isOpen={showMismatchAlert}
        onClose={() => {
          mismatchConfirmedRef.current = false;
          setShowMismatchAlert(false);
        }}
        onConfirm={() => {
          mismatchConfirmedRef.current = true;
          setShowMismatchAlert(false);
          submitFormRef.current?.();
        }}
        onChangeDenomination={() => {
          mismatchConfirmedRef.current = false;
          denominationPromptHandledRef.current = false;
          denominationSubmitModeRef.current = null;
          setShowMismatchAlert(false);
          setShowDenominationModal(true);
          setTimeout(() => firstDenomInputRef.current?.focus(), 100);
        }}
        denomTotal={mismatchData.denomTotal}
        amountValue={mismatchData.amountValue}
        returnAmount={mismatchData.returnAmount}
      />

      {/* Payment Details Modal */}
      {showPaymentModal && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/60 backdrop-blur-sm p-4">
          <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full overflow-hidden animate-in fade-in zoom-in duration-200">
            <div className="p-6 border-b border-gray-100 flex items-center justify-between">
              <h3 className="text-xl font-black text-gray-800 tracking-tight">
                Payment Details
              </h3>
              <button
                onClick={() => {
                  setShowPaymentModal(false);
                }}
                className="text-gray-400 hover:text-gray-600 transition-colors text-2xl"
              >
                ×
              </button>
            </div>
            <div className="p-6 space-y-4">
              {/* Timer */}
              <div className="flex items-center justify-between text-sm font-semibold text-gray-600">
                <span>Auto-close in:</span>
                <span id="payment-modal-timer">{paymentModalTimer}</span>
              </div>

              {accountDetails && (
                <div className="space-y-3">
                  <p className="text-[11px] uppercase text-gray-500 font-bold">
                    Account Details
                  </p>
                  <p className="mt-2 text-sm font-semibold text-gray-800">
                    Holder: {accountDetails.holder_name || "â€”"}
                  </p>
                  <p className="mt-1 text-sm text-gray-700">
                    Account Number: {accountDetails.account_number || "â€”"}
                  </p>
                  <p className="mt-1 text-sm text-gray-700">
                    IFSC Code: {accountDetails.ifsc_code || "â€”"}
                  </p>
                </div>
              )}

              {upiId && (
                <div className="space-y-3">
                  <p className="text-[11px] uppercase text-gray-500 font-bold">
                    UPI Details
                  </p>
                  <p className="mt-2 text-sm font-semibold text-gray-800">
                    UPI ID: {upiId}
                  </p>
                  <div className="flex min-h-[240px] items-center justify-center rounded-2xl border border-dashed border-slate-200 bg-slate-50 p-4">
                    {paymentQrCode ? (
                      <img
                        src={paymentQrCode}
                        alt="UPI payment QR code"
                        className="h-56 w-56 rounded-2xl bg-white p-3 shadow-sm"
                      />
                    ) : (
                      <p className="px-6 text-center text-sm text-slate-500">
                        {paymentQrError || "Generating QR code..."}
                      </p>
                    )}
                  </div>
                </div>
              )}

              {rawPaymentDetails && (
                <div className="space-y-3">
                  <p className="text-[11px] uppercase text-gray-500 font-bold">
                    Payment Details
                  </p>
                  <p className="mt-2 whitespace-pre-wrap text-sm text-gray-800">
                    {rawPaymentDetails}
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
      {showThaaiMamanModal && (
        <ThaaiMamanLineUpModal
          onClose={(isSaved) => {
            setShowThaaiMamanModal(false);
            if (isSaved) {
              fetchMoiList(false);
            }
          }}
        />
      )}
    </div>
  );
};

export default TrainingPage;
function numberToWords(num) {
  const n = parseInt(num, 10);
  if (isNaN(n) || n === 0) return "";

  const ones = ["", "ஒன்று", "இரண்டு", "மூன்று", "நான்கு", "ஐந்து", "ஆறு", "ஏழு", "எட்டு", "ஒன்பது"];
  const tens1 = ["பத்து", "பதினொன்று", "பன்னிரண்டு", "பதின்மூன்று", "பதினான்கு", "பதினைந்து", "பதினாறு", "பதினேழு", "பதினெட்டு", "பத்தொன்பது"];
  const tens2 = ["", "பத்து", "இருபது", "முப்பது", "நாற்பது", "ஐம்பது", "அறுபது", "எழுபது", "எண்பது", "தொண்ணூறு"];

  const h_exact = ["", "நூறு", "இருநூறு", "முந்நூறு", "நானூறு", "ஐநூறு", "அறுநூறு", "எழுநூறு", "எண்ணூறு", "தொள்ளாயிரம்"];
  const h_prefix = ["", "நூற்று", "இருநூற்று", "முந்நூற்று", "நானூற்று", "ஐநூற்று", "அறுநூற்று", "எழுநூற்று", "எண்ணூற்று", "தொள்ளாயிரத்து"];

  function parse99(v) {
    if (v === 0) return "";
    if (v < 10) return ones[v];
    if (v < 20) return tens1[v - 10];
    const t = Math.floor(v / 10);
    const o = v % 10;
    return tens2[t] + (o > 0 ? " " + ones[o] : "");
  }

  function parse999(v) {
    if (v === 0) return "";
    if (v < 100) return parse99(v);
    const h = Math.floor(v / 100);
    const rem = v % 100;
    if (rem === 0) return h_exact[h];
    return h_prefix[h] + " " + parse99(rem);
  }

  let str = "";
  let val = n;

  const crore = Math.floor(val / 10000000);
  val %= 10000000;
  const lakh = Math.floor(val / 100000);
  val %= 100000;
  const thousand = Math.floor(val / 1000);
  val %= 1000;

  if (crore > 0) {
    str += parse99(crore) + (val > 0 ? " கோடியே " : " கோடி ");
  }
  if (lakh > 0) {
    str += parse99(lakh) + (val > 0 ? " லட்சத்து " : " லட்சம் ");
  }
  if (thousand > 0) {
    if (thousand === 1) {
      str += (val > 0 ? "ஆயிரத்து " : "ஆயிரம் ");
    } else {
      str += parse99(thousand) + (val > 0 ? " ஆயிரத்து " : " ஆயிரம் ");
    }
  }
  if (val > 0) {
    str += parse999(val);
  }

  return str.trim();
}
